import PropTypes from "prop-types"
import React, { useState, useCallback, useRef, useEffect } from "react"
import {
  Container,
  Table,
  Collapse,
  Button,
  Row,
  Col,
  Tooltip,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  Input,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
} from "reactstrap"

import { useNavigate, Link } from "react-router-dom"
import Select from "react-select"
import CreatableSelect from 'react-select/creatable';

import "chartist/dist/scss/chartist.scss"
import { DatePicker, DateRangePicker, Stack } from "rsuite"
const { combine } = DatePicker
//i18n
import { withTranslation } from "react-i18next"
//class
import chevleft from "assets/images/services-icon/chev-left.png"
import { useFormik } from "formik"
import * as yup from "yup"
import moment from "moment"

import awicon from "../../assets/images/services-icon/coin.png"
import classnames from "classnames"
import axios from "axios"
import { BASE_URL, optionCoin, LCMS_API_BASE_URL } from "../../global"
//popup

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { MathJax, MathJaxContext } from "better-react-mathjax"
import ActivityToPDFConverter from "../../components/ActivityPDFConverter/ActivityToPDFConverter";
import { sortLibraryFolders, sortLibraryBySubjectName, groupItemsByFolderActivityType } from "./library-utility"
import { getUserSetting } from "../../common/user-setting"
import {
  getAuthToken,
  getEffectiveTutorKey,
  getActAsTutorName,
  isAdminMode,
  shouldBlockWorkApi,
  isAdminShellBlockedError,
  TUTOR_ADMIN_VIEW_CHANGED,
} from "../../common/auth/tutor-admin-auth"
const LibraryDetails = props => {
  const navigate = useNavigate()

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSubmitting1, setIsSubmitting1] = useState(false)
  const formRef = useRef(null)

  const optionGroup3 = [
    { label: "Video", value: "1" },
    { label: "Link", value: "3" },
    { label: "Task", value: "4" },
    { label: "Work sheet", value: "5" },
    { label: "File", value: "10" },
  ]
  const optionGroupedit3 = [
    { label: "Video", value: 1 },
    { label: "Link", value: 3 },
    { label: "Task", value: 4 },
    { label: "Work sheet", value: 5 },
    { label: "Files", value: 10 },
  ]

  const optionGroup4 = [
    // {
    //   label: "Select Duration",
    //   options: [
    { label: "Less than 2 minutes", value: "AlLess than 2 minutesl" },
    { label: "2-5 minutes", value: "2-5 minutes" },
    { label: "5-10 minutes", value: "5-10 minutes" },
    { label: "10-15 minutes", value: "10-15 minutes" },
    { label: "15-20 minutes", value: "15-20 minutes" },
    { label: "20-30 minutes", value: "20-30 minutes" },
    { label: "5-10 minutes", value: "5-10 minutes" },
    { label: "30-60 minutes", value: "30-60 minutes" },
    //   ],
    // },
  ]

 
  //accordion

  // const [col2, setCol2] = useState(false)
  // const [col3, setCol3] = useState(false)

  // function t_col1() {
  //   setCol1(!col1)
  //   //setCol1(true)
  //   setCol2(false)
  //   setCol3(false)
  // }
  // function t_col2() {
  //   setCol2(!col2)
  //   setCol1(false)
  //   //setCol2(true)
  //   setCol3(false)
  // }
  // function t_col3() {
  //   setCol1(false)
  //   setCol2(false)
  //   //setCol3(true)
  //   setCol3(!col3)
  // }

  //modal add
  const [modal_large, setmodal_large] = useState(false)
  const tog_large = () => {
    setmodal_large(!modal_large)
  }

  //modal edit
  const [modal_large1, setmodal_large1] = useState(false)
  const tog_large1 = () => {
    setmodal_large1(!modal_large1)
  }

  //delete modal
  const [modal_center, setmodal_center] = useState(false)
  const tog_center = () => {
    setmodal_center(!modal_center)
  }

  //tooltip
  const [ttop, setttop] = useState(false)
  const [ttop2, setttop2] = useState(false)

  const [ttop1, setttop1] = useState(false)

  // const [date, setDate] = useState(new Date());
  const [date, setDate] = useState([null, null])
  const [subject, setSubject] = useState("")
  const [type, setType] = useState("")
  const [status, setStatus] = useState("")
  //const [Alldata, setAllData] = useState([]);
  const [dataTableData, setDataTableData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [singleMylibraryData, setSingleMyLibrary] = useState([])
  const [allEditMylibrarydata, setAllEditMylibrarydata] = useState([])
  const [allDeleteMylibrarydata, setAllDeleteMylibrarydata] = useState([])
  const [subjectdata, setSubjectData] = useState([])
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [selectedOption3, setSelectedOption] = useState("")
  const [selectedOption3edit, setSelectedOptionedit] = useState("")
  const [inputValue, setInputValue] = useState("")
  const [isUserDeleteSubmitting, setIsUserDeleteSubmitting] = useState(false)
  const [summativeFilterActivity, setSummativeFilterActivity] = useState([])

  const [dataTableOtherTutorData, setDataTableOtherTutorData] = useState([])
  const [filteredOtherTutorData, setFilteredOtherTutorData] = useState([])
  const [libraryTabs, setlibraryTabs] = useState("1")
  const [adminViewName, setAdminViewName] = useState(getActAsTutorName() || "")
  const adminMode = isAdminMode()
  function toggleLibraryCustomTab(tab) {
    if (libraryTabs !== tab) {
      setlibraryTabs(tab)
    }
  }
  const userSetting = getUserSetting();

  const reloadLibraryData = () => {
    fetchData()
    fetchData2()
    fetchOtherTutorData()
    fetchSummativeListData()
  }

  const fetchData = async () => {
    try {
      if (shouldBlockWorkApi()) {
        setDataTableData([])
        setFilteredData([])
        return
      }

      const token = getAuthToken()
      if (token && token != "" && token != null) {
        // setLoading(true);
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
        const response = await axios.post(
          BASE_URL + "mylibrary/getAllMyLibrary",
          {}
        )
        const myLibItems = response?.data || [];
        const sortedMyLibItems = sortLibraryBySubjectName(myLibItems);

        setDataTableData(sortedMyLibItems)
        setFilteredData(sortedMyLibItems)
      } else {
        navigate("/login")
      } /*  */
      // setAllData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }
// other tutor library data fetch start
  const fetchOtherTutorData = async () => {
    try {
      if (shouldBlockWorkApi()) {
        setDataTableOtherTutorData([])
        setFilteredOtherTutorData([])
        return
      }

      const token = getAuthToken()
      if (token && token != "" && token != null) {
        // setLoading(true);
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
        const response = await axios.post(
          BASE_URL + "mylibrary/getAllOtherMyLibrary",
          {}
        )
        const otherMyLibItems = response?.data || [];
        const sortedOtherMyLibItems = sortLibraryBySubjectName(otherMyLibItems);

        setDataTableOtherTutorData(sortedOtherMyLibItems)
        setFilteredOtherTutorData(sortedOtherMyLibItems)
      } else {
        navigate("/login")
      } /*  */
      // setAllData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  // other tutor library data fetch end

  const handleRowEditActivityClick = async e => {
    //console.log(e)
    if (getAuthToken() && getAuthToken() != "" && getAuthToken() != null) {
      // setLoading(true);
      axios.defaults.headers.common["Authorization"] = `Bearer ${getAuthToken()}`
      const response = await axios
        .post(BASE_URL + "mylibrary/getSingleMyLibrary", {
          pk_tutor_library_item_key: e.pk_tutor_library_item_key,
        })
        .then(responsesinglemylibrary => {
          if (responsesinglemylibrary.data.length > 0) {
            setAllEditMylibrarydata(responsesinglemylibrary.data)
          } else {
            toast.error(
              "Failure! Unable to Editable session. Try again later",
              {
                autoClose: 3000, // 3 seconds in this example
              }
            )
          }
        })
        .catch(error => {
          toast.error("Failure! Unable to Editable session. Try again later", {
            autoClose: 3000, // 3 seconds in this example
          })
        })
    }
    // console.log(e.sest_from_date);
    // console.log(e.sest_start_time);
  }

  const fetchData2 = async () => {
    try {
      if (shouldBlockWorkApi()) {
        setSubjectData([])
        return
      }

      const token = getAuthToken()
      if (token && token != "" && token != null) {
        // setLoading(true);
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
        const responseSubject = await axios.post(
          BASE_URL + "mylibrary/getSubjectbycentre",
          {}
        )

        const subjectOptions = responseSubject.data.map(option => ({
          value: option.subject_id,
          label: option.sub_name,
        }))
        setSubjectData(subjectOptions)
      } else {
        navigate("/login")
      } /*  */
      // setAllData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }
  const [allFolderOptions, setAllFolderOptions] = useState([]);

  // Load all data once
  const fetchFolderData = async () => {
  try {
      if (shouldBlockWorkApi()) {
        setAllFolderOptions([])
        return
      }

      const token = getAuthToken()
      if (!token) {
        return
      }

      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      const res = await axios.get(`${BASE_URL}mylibrary/libraryFolders`);
      if(res?.data?.length > 0){
        const sorted = sortLibraryFolders(res.data);

        const formatted = sorted.map(item => ({
          label: item.folder_name,
          value: item.pk_folder_key,
        }));
        setAllFolderOptions(formatted);
      }else{
        setAllFolderOptions([]);
      }
    } catch (err) {
      console.error('Error fetching folders:', err);
      setAllFolderOptions([]);
    }
  }
  useEffect(() => {
    fetchFolderData();
  }, []);


  useEffect(() => {
    fetchData()
    fetchData2()
    fetchOtherTutorData()
    // fetchData3();
  }, [date, subject, type, status])

  useEffect(() => {
    const handleAdminViewChanged = () => {
      setAdminViewName(getActAsTutorName() || "")
      reloadLibraryData()
      fetchFolderData()
    }

    window.addEventListener(TUTOR_ADMIN_VIEW_CHANGED, handleAdminViewChanged)
    return () => {
      window.removeEventListener(TUTOR_ADMIN_VIEW_CHANGED, handleAdminViewChanged)
    }
  }, [date, subject, type, status])

  useEffect(() => {
    const activitytype = allEditMylibrarydata[0]
      ? allEditMylibrarydata[0].activity_type
      : ""

    setSelectedOptionedit(activitytype)
  }, [allEditMylibrarydata])

  /* Add activity form function*/

  const basicSchema = yup.object().shape({
    act_subject: yup.string().required("Subject name is required."),
    act_type: yup.string().required("Activity type is required."),
    act_name: yup.string().required("Activity name is required.").min(2, "Minimum 2 characters required").max(250, "Maximum 250 characters is required.").matches(/^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/, "Avoid start & end with a space or comma"),
    act_source: yup.string().required("Source is required."),
    act_duration: yup.string().required("Duration is required."),
    act_link: yup
      .string()
      .when("act_type", {
        is: "3",
        then: (schema) => schema.required("Link is required.").matches(
          /^(https?:\/\/|www\.)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/[a-zA-Z0-9-._~:/?#\[\]@!$&'()*+,;=%]*)?$/,
          "Enter a valid link"
        ),
        otherwise: (schema) => schema.notRequired(),
      }),
    act_video: yup
      .string()
      .when("act_type", {
        is: "1",
        then: (schema) => schema.required("Video is required.").matches(
          /^(https?:\/\/|www\.)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/[a-zA-Z0-9-._~:/?#\[\]@!$&'()*+,;=%]*)?$/,
          "Enter a valid video link"
        ),
        otherwise: (schema) => schema.notRequired(),
      }),
    act_file: yup
      .mixed()
      .when("act_type", {
        is: (val) => (val == "5" || val == "10"),
        then: (schema) => schema.required("File is required.").test(
          "act_file",
          "File size should not exceed 50MB",
          (value) => !value || value.size <= 50 * 1024 * 1024
        ),
        otherwise: (schema) => schema.notRequired(),
      }),
    act_coin: yup.string().required("Coins is required."),  
    act_folder: yup.object().shape({
      label: yup.string().required('Required'),
      value: yup.string().required('Required'),
    }).nullable().required('Folder Name is required'),
  })

  const initialValues = {
    /*subjects*/

    act_subject: "",
    act_type: "",
    act_name: "",
    act_source: "",
    act_duration: "",
    act_file: null,
    act_link: "",
    act_video: "",
    act_description: "",
    act_coin: "2",
    act_folder: null,
  }

  const formik = useFormik({
    initialValues,
    validationSchema: basicSchema,
    enableReinitialize: true,
    //  onSubmit,
    onSubmit: async formValues => {
      // setIsSubmitting(true);

      try {
        if (getAuthToken() && getAuthToken() != "" && getAuthToken() != null) {
          // setLoading(true);

          axios.defaults.headers.common["Authorization"] = `Bearer ${getAuthToken()}`

          if (values.act_file && (values.act_type=='5' || values.act_type=='10')) {
            const formData = new FormData()
            formData.append("act_subject", values.act_subject)
            formData.append("act_type", values.act_type)
            formData.append("act_name", values.act_name)
            formData.append("act_source", values.act_source)
            formData.append("act_duration", values.act_duration)
            formData.append("act_file", values.act_file)
            formData.append("act_description", values.act_description)
            formData.append("act_coin", values.act_coin)
            formData.append("act_folder", JSON.stringify(values.act_folder))

            const response = await axios.post(
              BASE_URL + "mylibrary/createMyLibrary1",
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )

            if (response.data.status && response.data.status === true) {
              // Reset the form
              //formRef.current.reset();
              fetchData()
              fetchFolderData();
              toast.success(`Activity added to My Library`, {
                autoClose: 3000, // 3 seconds in this example
              })
              setmodal_large(false)
              formik.setFieldValue("act_subject", "")
              formik.setFieldValue("act_type", "")
              formik.setFieldValue("act_name", "")
              formik.setFieldValue("act_source", "")
              formik.setFieldValue("act_duration", "")
              formik.setFieldValue("act_file", null)
              formik.setFieldValue("act_link", "")
              formik.setFieldValue("act_video", "")
              formik.setFieldValue("act_description", "")
              formik.setFieldValue("act_coin", "")
              formik.setFieldValue("act_folder", null)
              formik.resetForm();
              // After 3 seconds, redirect to another page
              // setTimeout(function () {
              //   navigate("/Subject");
              // }, 3000); // 3000 milliseconds, which is equivalent to 3 seconds

              setIsSubmitting(false) // Re-enable the submit button
            } else {
              toast.error(
                "Failure! Unable to create activity in my library. Try again later",
                {
                  autoClose: 3000, // 3 seconds in this example
                }
              )

              setIsSubmitting(false) // Re-enable the submit button
            }
          } else {
            const response = await axios.post(
              BASE_URL + "mylibrary/createMyLibrary",
              {
                ...formValues,
              }
            )

            if (response.data.status && response.data.status === true) {
              // Reset the form
              //formRef.current.reset();
              fetchData()
              fetchFolderData();
             
              toast.success(`Activity added to My Library`, {
                autoClose: 3000, // 3 seconds in this example
              })
              setmodal_large(false)
              formik.setFieldValue("act_subject", "")
              formik.setFieldValue("act_type", "")
              formik.setFieldValue("act_name", "")
              formik.setFieldValue("act_source", "")
              formik.setFieldValue("act_duration", "")
              formik.setFieldValue("act_file", null)
              formik.setFieldValue("act_link", "")
              formik.setFieldValue("act_video", "")
              formik.setFieldValue("act_description", "")
              formik.setFieldValue("act_coin", "")
              formik.setFieldValue("act_folder", null)
              formik.resetForm();
              // After 3 seconds, redirect to another page
              // setTimeout(function () {
              //   navigate("/Subject");
              // }, 3000); // 3000 milliseconds, which is equivalent to 3 seconds

              setIsSubmitting(false) // Re-enable the submit button
            } else {
              toast.error(
                "Failure! Unable to create activity in my library. Try again laters",
                {
                  autoClose: 3000, // 3 seconds in this example
                }
              )

              setIsSubmitting(false) // Re-enable the submit button
            }
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error)
        toast.error(
          "Failure! Unable to create activity in my library. Try again later",
          {
            autoClose: 3000, // 3 seconds in this example
          }
        )

        setIsSubmitting(false) // Re-enable the submit button
      } finally {
        setIsSubmitting(false) // Re-enable the submit button
      }
    },
  })

  // Now, you can set variables as needed:
  const values = formik.values
  const handleBlur = formik.handleBlur
  const touched = formik.touched
  const handleChange = formik.handleChange
  const handleFileChange = formik.handleChange

  const errors = formik.errors
  const handleSubmit = formik.handleSubmit
  const setTouched = formik.setTouched
  const resetForm = formik.resetForm
  const setValues = formik.setValues
  const handleReset = formik.handleReset
   // Handle select or create
  const handleFolderChange = async (selectedOption) => {
    if (selectedOption?.__isNew__) {
      // const res = await axios.post('/api/items', { name: selectedOption.label });
      const newOption = { label: selectedOption.label, value: "NEWFOLDER" };
      setAllFolderOptions(prev => [
        ...prev.filter(opt => opt.value !== 'NEWFOLDER'),
        newOption
      ]);
      // setAllFolderOptions(prev => [...prev, newOption]);
      setValues({
        ...formik.values, // retain other values in form
        act_folder: newOption, // update only 'act_folder'
      });
    } else {
      setValues({
        ...formik.values, // retain other values in form
        act_folder: selectedOption, // update only 'act_folder'
      });
    }
  };


  // console.log(values)
  // console.log(errors)
  /* Edit activity form function*/

  const basicSchema1 = yup.object().shape({
    act_subject: yup.string().required("Subject name is required."),
    act_type: yup.string().required("Activity type is required."),
    act_name: yup.string().required("Activity name is required.").min(2, "Minimum 2 characters required").max(250, "Maximum 250 characters is required.").matches(/^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/, "Avoid start & end with a space or comma"),
    act_source: yup.string().required("Source is required."),
    act_duration: yup.string().required("Duration is required."),
    act_link: yup
      .string()
      .when("act_type", {
        is: "3",
        then: (schema) => schema.required("Link is required.").matches(
          /^(https?:\/\/|www\.)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/[a-zA-Z0-9-._~:/?#\[\]@!$&'()*+,;=%]*)?$/,
          "Enter a valid link"
        ),
        otherwise: (schema) => schema.notRequired(),
      }),
    act_video: yup
      .string()
      .when("act_type", {
        is: "1",
        then: (schema) => schema.required("Video is required.").matches(
          /^(https?:\/\/|www\.)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/[a-zA-Z0-9-._~:/?#\[\]@!$&'()*+,;=%]*)?$/,
          "Enter a valid video link"
        ),
        otherwise: (schema) => schema.notRequired(),
      }),
    act_file: yup
      .mixed()
      .when("act_type", {
        is: (val) => (val == "5" || val == "10"),
        then: (schema) => schema.required("File is required.").test(
          "act_file",
          "File size should not exceed 50MB",
          (value) => {
            if (!value) return false; // required
            if (typeof value === "string") return true; // allow filename string (edit mode)
            if (value instanceof File) return value.size <= 50 * 1024 * 1024; // validate file size
            return false; // anything else is invalid
          }
        ),
        otherwise: (schema) => schema.notRequired(),
      }),
    act_coin: yup.string().required("Coins is required."), 
    act_folder: yup.object().shape({
      label: yup.string().required('Required'),
      value: yup.string().required('Required'),
    }).nullable().required('Folder Name is required'), 
  })

  // activity_type
  // created_on
  // deleted_on
  // duration
  // fk_activity_topic_id
  // fk_sub_id
  // fk_tut_key
  // is_deleted
  // is_hide
  // link
  // name
  // pk_tutor_library_item_id
  // pk_tutor_library_item_key
  // source
  // updated_on

  const initialValues1 = {
    /*subjects*/
    // pk_tutor_library_item_key: allEditMylibrarydata ? allEditMylibrarydata.pk_tutor_library_item_key : '',
    act_subject: allEditMylibrarydata[0]
      ? allEditMylibrarydata[0].fk_sub_id
      : "",
    act_type: allEditMylibrarydata[0]
      ? allEditMylibrarydata[0].activity_type
      : "",
    act_name: allEditMylibrarydata[0] ? allEditMylibrarydata[0].name : "",
    act_source: allEditMylibrarydata[0] ? allEditMylibrarydata[0].source : "",
    act_duration: allEditMylibrarydata[0]
      ? allEditMylibrarydata[0].duration
      : "",
    act_link:
      allEditMylibrarydata[0] && allEditMylibrarydata[0].activity_type === 3
        ? allEditMylibrarydata[0].link
        : "",
    act_video:
      allEditMylibrarydata[0] && allEditMylibrarydata[0].activity_type === 1
        ? allEditMylibrarydata[0].link
        : "",
    act_file1:
      allEditMylibrarydata[0] && (allEditMylibrarydata[0].activity_type === 5 || allEditMylibrarydata[0].activity_type === 10)
        ? allEditMylibrarydata[0].link
        : "",
    act_file:
      allEditMylibrarydata[0] && (allEditMylibrarydata[0].activity_type === 5 || allEditMylibrarydata[0].activity_type === 10)
        ? allEditMylibrarydata[0].link
        : "",
    act_description: allEditMylibrarydata[0] ? allEditMylibrarydata[0].description : "",
    act_coin: allEditMylibrarydata[0] && allEditMylibrarydata[0].coins ? allEditMylibrarydata[0].coins : "2",
    act_folder: allEditMylibrarydata[0] && allEditMylibrarydata[0].fk_folder_key ? 
    { label: allEditMylibrarydata[0].folder_name, value: allEditMylibrarydata[0].fk_folder_key } : null,
  }
  // console.log('esf',allEditMylibrarydata)

  const formik1 = useFormik({
    initialValues: initialValues1,
    validationSchema: basicSchema1,
    enableReinitialize: true,
    //  onSubmit,
    onSubmit: async formValues => {
      try {
        if (getAuthToken() && getAuthToken() != "" && getAuthToken() != null) {
          // setLoading(true);
          axios.defaults.headers.common["Authorization"] = `Bearer ${getAuthToken()}`
          if (values1.act_file instanceof File && (values1.act_type=='5' || values1.act_type=='10')) {
            const formData = new FormData()
            formData.append(
              "pk_tutor_library_item_key",
              allEditMylibrarydata[0].pk_tutor_library_item_key
            )
            formData.append("act_subject", values1.act_subject)
            formData.append("act_type", values1.act_type)
            formData.append("act_name", values1.act_name)
            formData.append("act_source", values1.act_source)
            formData.append("act_duration", values1.act_duration)
            formData.append("act_file", values1.act_file)
            formData.append("act_description", values1.act_description)
            formData.append("act_coin", values1.act_coin)
            formData.append("act_folder", JSON.stringify(values1.act_folder))

            const response = await axios.post(
              BASE_URL + "mylibrary/updateMyLibrary1",
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )

            // const response = await axios.put(BASE_URL+'mylibrary/updateMyLibrary', {
            //   pk_tutor_library_item_key: allEditMylibrarydata[0].pk_tutor_library_item_key,
            //   ...formValues
            // });
            // console.log("response", response)

            if (response.data.status && response.data.status === true) {
              // Reset the form

              // console.log(response)
              toast.success("Activity updated successfully", {
                autoClose: 3000,
              })
              fetchData()
              fetchFolderData();
              setmodal_large1(false)
              setIsSubmitting1(false)
              
            } else {
              formRef.current.reset()
              toast.error(
                "Failure! Unable to update the activity in my library. Try again later",
                {
                  autoClose: 3000, // 3 seconds in this example
                }
              )

              setIsSubmitting1(false) // Re-enable the submit button
            }
          } else {
            const response = await axios.post(
              BASE_URL + "mylibrary/updateMyLibrary",
              {
                pk_tutor_library_item_key:
                  allEditMylibrarydata[0].pk_tutor_library_item_key,
                ...formValues,
              }
            )

            // Reset the form
            //formRef.current.reset();

            if (response.data.status && response.data.status === true) {
              // console.log(response)
              toast.success("Activity updated successfully", {
                autoClose: 3000, // 3 seconds in this example
              })
              fetchData()
              fetchFolderData();
              setmodal_large1(false)
              setIsSubmitting1(false) // Re-enable the submit button
              
            } else {
              toast.error(
                "Failure! Unable to update the activity in my library. Try again later",
                {
                  autoClose: 3000, // 3 seconds in this example
                }
              )

              setIsSubmitting1(false) // Re-enable the submit button
            }
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error)
        toast.error(
          "Failure! Unable to update the activity in my library. Try again later",
          {
            autoClose: 3000, // 3 seconds in this example
          }
        )

        setIsSubmitting1(false) // Re-enable the submit button
      } finally {
        setIsSubmitting1(false) // Re-enable the submit button
      }
    },
  })

  // Now, you can set variables as needed:
  const values1 = formik1.values
  const handleBlur1 = formik1.handleBlur
  const touched1 = formik1.touched
  const handleChange1 = formik1.handleChange
  const errors1 = formik1.errors
  const handleSubmit1 = formik1.handleSubmit
  const setTouched1 = formik1.setTouched
  const resetForm1 = formik1.resetForm
  const setValues1 = formik1.setValues
  const handleReset1 = formik1.handleReset
  // Handle select or create
  const handleUpdateFolderChange = async (selectedOption) => {
    if (selectedOption?.__isNew__) {
      // const res = await axios.post('/api/items', { name: selectedOption.label });
      const newOption = { label: selectedOption.label, value: "NEWFOLDER" };
      setAllFolderOptions(prev => [
        ...prev.filter(opt => opt.value !== 'NEWFOLDER'),
        newOption
      ]);
      // setAllFolderOptions(prev => [...prev, newOption]);
      setValues1({
        ...formik1.values, // retain other values in form
        act_folder: newOption, // update only 'act_folder'
      });
    } else {
      setValues1({
        ...formik1.values, // retain other values in form
        act_folder: selectedOption, // update only 'act_folder'
      });
    }
  };
  const handleRemoveFile = () => {
    formik1.setFieldValue("act_file1", "")
  }
  function onSubmitUserDelete() {
    setIsUserDeleteSubmitting(true)

    if (getAuthToken() && getAuthToken() != "" && getAuthToken() != null) {
      // setLoading(true);
      axios.defaults.headers.common["Authorization"] = `Bearer ${getAuthToken()}`
      const response = axios
        .post(BASE_URL + "mylibrary/deleteMyLibrary", {
          pk_tutor_library_item_key: allDeleteMylibrarydata,
        })
        .then(responseuserdelete => {
          // console.log(responseuserdelete)
          if (responseuserdelete.data.status == true) {
            // Reset the form
            //formRef.current.reset();

            toast.success("Activity deleted successfully", {
              autoClose: 3000, // 3 seconds in this example
            })

            fetchData()
            setmodal_center(false)
            setIsUserDeleteSubmitting(false)

            // } else if (responseuserdelete.data.data === 2) {
            //   toast.error("Failure! Unable to delete session. student enrolled this session", {
            //     autoClose: 3000, // 3 seconds in this example
            //   });
            //   fetchData();
            //   setDeleteShow(false);
            //   setIsUserDeleteSubmitting(false);
          } else {
            toast.error(
              "Failure! Unable to delete the activity from my library. Try again later",
              {
                autoClose: 3000, // 3 seconds in this example
              }
            )
            setIsUserDeleteSubmitting(false)
          }
        })
        .catch(error => {
          // Handle any errors that occurred during the request
          toast.error("Failure! Unable to delete activity. Try again later", {
            autoClose: 3000, // 3 seconds in this example
          })
          setIsUserDeleteSubmitting(false)
        })
    }
  }

  // const resetFormFields = (resetForm, setValues, initialValues) => {
  //   resetForm(); // Reset Formik-controlled fields
  // };

  // function handleClick(event) {
  //   event.preventDefault();
  //   console.info('You clicked a breadcrumb.');
  // }

  const [openItems, setOpenItems] = useState(
    Array(dataTableData.length).fill(true)
  )
  // const [openTypeItems, setOpenTypeItems] = useState({})
  // Function to toggle the open/close state of a specific item
  const toggleItem = index => {
    const newOpenItems = [...openItems]
    newOpenItems[index] = !newOpenItems[index]
    setOpenItems(newOpenItems)
  }
  // const toggleTypeItem = (subjectIndex, type) => {
  //   setOpenTypeItems(prevState => ({
  //     ...prevState,
  //     [subjectIndex]: {
  //       ...prevState[subjectIndex],
  //       [type]: !prevState[subjectIndex]?.[type],
  //     },
  //   }))
  // }

  const handleInputChange = event => {
    setSelectedOption(event.target.value)
    setInputValue("")
  }

  const handleInputChangeEdit = event => {
    setSelectedOptionedit(event.target.value)
    setInputValue("")
  }

  const handleInputValueChange = event => {
    setInputValue(event.target.value)
  }

  const filterReset = () => {
    setDateValue([null, null])
    setfilterValue("")
    fetchData()
  }

  // function handleFilter(event) {
  //   const inputValue = event.target.value.trim().toLowerCase()
  //   const newData = dataTableData.filter(row => {
  //     return (
  //       (row.TutorLibraryItems.created_on != null || row.TutorLibraryItems.created_on != ""
  //         ? moment(row.created_on, "YYYY-MM-DDTHH:mm:ss.SSSZ").format(
  //             "DD-MM-YYYY"
  //           )
  //         : "-"
  //       ).includes(inputValue) ||
  //       (row.TutorLibraryItems.name != null || row.TutorLibraryItems.name != "" ? row.TutorLibraryItems.name : "-")
  //         .toLowerCase()
  //         .includes(inputValue) ||
  //         (row.TutorLibraryItems.source != null || row.TutorLibraryItems.source != "" ? row.TutorLibraryItems.source : "-")
  //         .toLowerCase()
  //         .includes(inputValue) ||
  //         (row.TutorLibraryItems.duration != null || row.TutorLibraryItems.duration != "" ? row.TutorLibraryItems.duration : "-")
  //         .toLowerCase()
  //         (row.TutorLibraryItems.activity_type != null || row.TutorLibraryItems.activity_type != "" ? row.TutorLibraryItems.activity_type : "-")
  //         .toLowerCase()
  //           .includes(inputValue)
  //     )
  //   })
  //   setDataTableData(newData)
  // }

  // const handleFilter = (event) => {
  //   const inputValue = event.target.value.trim().toLowerCase();

  //   if (inputValue === '') {
  //     setDataTableData(filteredData); // Reset to original data
  //     return; // Exit early
  //   }

  //   const newData = filteredData.filter(item => {
  //     // Filter based on TutorLibraryItems
  //     const filteredItems = item.TutorLibraryItems.filter(subItem => {
  //       const itemName = subItem.name ? subItem.name.toLowerCase() : '';
  //       const itemSource = subItem.source ? subItem.source.toLowerCase() : '';
  //       const itemDuration = subItem.duration ? subItem.duration.toLowerCase() : '';
  //       // const itemActivityType = subItem.activity_type ? subItem.activity_type.toLowerCase() : '';
  //       const itemCreatedOn = subItem.created_on ? moment(subItem.created_on, 'YYYY-MM-DDTHH:mm:ssZ').format('DD MMM YYYY').toLowerCase() : '';

  //       return (
  //         itemName.includes(inputValue) ||
  //         itemSource.includes(inputValue) ||
  //         itemDuration.includes(inputValue) ||
  //         // itemActivityType.includes(inputValue) ||
  //         itemCreatedOn.includes(inputValue)
  //       );
  //     });

  //     // Update item with filtered TutorLibraryItems
  //     return { ...item, TutorLibraryItems: filteredItems };
  //   });

  //   console.log(newData);
  //   setDataTableData(newData); // Update filtered data
  // };
  const [filterValue, setfilterValue] = useState("")
  const handleFilter = event => {
    setfilterValue(event.target.value)
    const inputValue = event.target.value.trim().toLowerCase()

    // Filter data based on search text
    const newData = filteredData.map(row => {
      const filteredItems = row.TutorLibraryItems.filter(subItem => {
        // console.log(subItem)
        const itemCoin = subItem.coins ? String(subItem.coins) : ""
        const itemName = subItem.name ? subItem.name.toLowerCase() : ""
        const itemSource = subItem.source ? subItem.source.toLowerCase() : ""
        const itemFolder = subItem.folder_name ? subItem.folder_name.toLowerCase() : ""
        const itemDescription = subItem.description ? subItem.description.toLowerCase() : ""
        const itemDuration = subItem.duration
          ? subItem.duration.toLowerCase()
          : ""
        const itemActivityType = subItem.activity_type
          ? subItem.activity_type
          : ""
        const itemCreatedOn = subItem.created_on
          ? moment(subItem.created_on, "YYYY-MM-DDTHH:mm:ssZ")
              .format("DD MMM YYYY")
              .toLowerCase()
          : ""
        
        // Additional filter condition based on sest_is_holidays
        const holidayType = itemActivityType
          ? itemActivityType == "1"
            ? "Video"
            : itemActivityType == "3"
            ? "Link"
            : itemActivityType == "4"
            ? "Task"
            : itemActivityType == "5"
            ? "WorkSheet"
            : "-"
          : "-"

        return (
          itemName.includes(inputValue) ||
          itemSource.includes(inputValue) ||
          itemFolder.includes(inputValue) ||
          itemDescription.includes(inputValue) ||
          itemDuration.includes(inputValue) ||
          itemCreatedOn.includes(inputValue) ||
          holidayType.toLowerCase().includes(inputValue) ||
          itemCoin.includes(inputValue)
        )
      })

      return { ...row, TutorLibraryItems: filteredItems }
    })


    const newSummativeData = summativeFilterActivity.filter(row => 
      row.name && row.name.toLowerCase().toLowerCase().includes(inputValue) ||
      row.createdAt && moment(row.createdAt, "YYYY-MM-DDTHH:mm:ssZ")
      .format("DD MMM YYYY")
      .toLowerCase().includes(inputValue)
    
    );

    //other tutor library filter
    const newOtherTutorData = filteredOtherTutorData.map(row => {
      const filteredOtherItems = row.TutorLibraryItems.filter(subItem => {
        // console.log(subItem)
        const itemCoin = subItem.coins ? String(subItem.coins) : ""
        const itemName = subItem.name ? subItem.name.toLowerCase() : ""
        const itemSource = subItem.source ? subItem.source.toLowerCase() : ""
        const itemFolder = subItem.folder_name ? subItem.folder_name.toLowerCase() : ""
        const itemDescription = subItem.description ? subItem.description.toLowerCase() : ""
        const itemTutorName = subItem.tut_fname ? subItem.tut_fname.toLowerCase()+' '+subItem.tut_surname.toLowerCase() : ""
        const itemDuration = subItem.duration
          ? subItem.duration.toLowerCase()
          : ""
        const itemActivityType = subItem.activity_type
          ? subItem.activity_type
          : ""
        const itemCreatedOn = subItem.created_on
          ? moment(subItem.created_on, "YYYY-MM-DDTHH:mm:ssZ")
              .format("DD MMM YYYY")
              .toLowerCase()
          : ""
        
        // Additional filter condition based on sest_is_holidays
        const holidayType = itemActivityType
          ? itemActivityType == "1"
            ? "Video"
            : itemActivityType == "3"
            ? "Link"
            : itemActivityType == "4"
            ? "Task"
            : itemActivityType == "5"
            ? "WorkSheet"
            : "-"
          : "-"

        return (
          itemName.includes(inputValue) ||
          itemSource.includes(inputValue) ||
          itemFolder.includes(inputValue) ||
          itemDescription.includes(inputValue) ||
          itemDuration.includes(inputValue) ||
          itemCreatedOn.includes(inputValue) ||
          holidayType.toLowerCase().includes(inputValue) ||
          itemCoin.includes(inputValue) ||
          itemTutorName.includes(inputValue)
        )
      })

      return { ...row, TutorLibraryItems: filteredOtherItems }
    })

    setSummativeActivity(newSummativeData);

    setDataTableOtherTutorData(newOtherTutorData);
    //console.log(newData); // Check console for filtered data
    setDataTableData(newData) // Update filtered data
  }

  const [dateValue, setDateValue] = useState([null, null])
  const handleDateChange = value => {
    // Do something with the selected date range

    // const filterStartDate= value[0] ? moment.utc(dateValue[0]).format('YYYY-MM-DD') : null;
    // const filterEndDate= value[1] ? moment.utc(dateValue[1]).format('YYYY-MM-DD') : null;

    // // Filter data based on search text
    // const newData = filteredData.map(row => {
    //   const filteredItems = row.TutorLibraryItems.filter(subItem => {

    //     const itemCreatedOn = subItem.created_on
    //       ? moment(subItem.created_on, 'YYYY-MM-DDTHH:mm:ssZ').format('DD MMM YYYY').toLowerCase()
    //       : '';

    //     return (
    //       itemCreatedOn.includes(inputValue)
    //     );
    //   });

    //   return { ...row, TutorLibraryItems: filteredItems };
    // });
    // setDataTableData(newData); // Update filtered data

    const filterStartDate = value[0]
      ? moment.utc(value[0]).startOf("day")
      : null
    const filterEndDate = value[1] ? moment.utc(value[1]).endOf("day") : null

    const newData = filteredData.map(row => {
      const filteredItems = row.TutorLibraryItems.filter(subItem => {
        const itemCreatedOn = subItem.created_on
          ? moment(subItem.created_on, "YYYY-MM-DDTHH:mm:ssZ")
          : null

        // Check if the created_on date is between filterStartDate and filterEndDate
        return (
          itemCreatedOn &&
          (!filterStartDate || itemCreatedOn.isSameOrAfter(filterStartDate)) &&
          (!filterEndDate || itemCreatedOn.isSameOrBefore(filterEndDate))
        )
      })

      return { ...row, TutorLibraryItems: filteredItems }
    })

    const newSummativeData = summativeFilterActivity.filter(row => 
                            row.createdAt &&
                            (!filterStartDate || moment(row.createdAt, "YYYY-MM-DDTHH:mm:ssZ").isSameOrAfter(filterStartDate)) &&
                            (!filterEndDate || moment(row.createdAt, "YYYY-MM-DDTHH:mm:ssZ").isSameOrBefore(filterEndDate))
                          );
    setSummativeActivity(newSummativeData);

    setDataTableData(newData) // Update filtered data
    setDateValue(value)
  }

  // const handleFilter = (event) => {
  //   const inputValue = event.target.value.trim().toLowerCase();
  //   setFilterValue(inputValue); // Update filter input value

  //   // Filter data based on input value without resetting data
  //   const newData = dataTableData.filter(row => {
  //     // Filter by parent subject name
  //     const subjectName = row.subject_name.toLowerCase().includes(inputValue);

  //     // Filter by TutorLibraryItems properties
  //     const filteredItems = row.TutorLibraryItems.filter(item => {
  //       const nameMatch = item.name && item.name.toLowerCase().includes(inputValue);
  //       const sourceMatch = item.source && item.source.toLowerCase().includes(inputValue);
  //       const durationMatch = item.duration && item.duration.toLowerCase().includes(inputValue);
  //       const createdOnMatch = item.created_on && moment(item.created_on, "YYYY-MM-DDTHH:mm:ss.SSSZ")
  //         .format("DD-MM-YYYY")
  //         .includes(inputValue);

  //       // Return true if any of the conditions match
  //       return nameMatch || sourceMatch || durationMatch || createdOnMatch;
  //     });

  //     // Include rows where either the subject name or any TutorLibraryItems match
  //     return subjectName || filteredItems.length > 0;
  //   });

  //   setDataTableData(newData); // Update displayed data
  // };
  const displayOrDash = (value) => {
    return value == null || value === "" ? "-" : value;
  };


  const activityTypeMap = optionGroup3.reduce((map, item) => {
    map[item.value] = item.label
    return map
  }, {})


const [openFolderItems, setOpenFolderItems] = useState({})
const [openTypeItems, setOpenTypeItems] = useState({})


const toggleFolderItem = (subjectIndex, folderKey) => {
  setOpenFolderItems(prev => ({
    ...prev,
    [subjectIndex]: {
      ...(prev[subjectIndex] || {}),
      [folderKey]: !prev[subjectIndex]?.[folderKey]
    }
  }))
}

const toggleTypeItem = (subjectIndex, folderKey, type) => {
  setOpenTypeItems(prev => ({
    ...prev,
    [subjectIndex]: {
      ...(prev[subjectIndex] || {}),
      [folderKey]: {
        ...(prev[subjectIndex]?.[folderKey] || {}),
        [type]: !prev[subjectIndex]?.[folderKey]?.[type]
      }
    }
  }))
}


//Summative start

const handle_summative = () =>{
  navigate("/create-summative")
}

const [summativeActivity, setSummativeActivity] = useState([])
 const fetchSummativeListData = async () => {
    setSummativeActivity([])
    try {
      if (shouldBlockWorkApi()) {
        setSummativeFilterActivity([])
        return
      }

      const token = getAuthToken()
      if (token && token != "" && token != null) {
        
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
          const responseSummative = await axios.post(LCMS_API_BASE_URL + "summative/find", {
                tutorKey: getEffectiveTutorKey()
            }).then(responseSummative => {

              if (responseSummative?.status === 201) {
                const activitiesDatalevel = responseSummative.data;
               
                if(activitiesDatalevel?.data){
                  setSummativeActivity(activitiesDatalevel?.data || []);
                  setSummativeFilterActivity(activitiesDatalevel?.data || []);
                }else{
                  setSummativeActivity([]);
                  setSummativeFilterActivity([]);
                }
                
              } else {
                toast.error("Activity details not found! Please try again.", {
                  autoClose: 3000, // 3 seconds
                });
              }
             
            })
            .catch(error => {
              if (error?.suppressedAdminShell || isAdminShellBlockedError(error)) {
                return
              }
              console.error("Error fetching options from API: ", error);
               // Not process the logout because tutor api working fine continue process.

              // if (
              //   (error?.response?.status === 403 || error?.response?.status === 401) &&
              //   (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
              // ) {
              //   localStorage.clear()
              //   navigate("/login")
              // }
              // Handle API error response
              if (error.response) {
                // Server responded with a status other than 2xx
                const errorMessages = error?.response?.data?.errors
                  ? error?.response?.data?.errors.map(err => err.message).join("\n")
                  : "An error occurred. Please try again.";
                  toast.error(`Error: ${errorMessages}`, {
                    autoClose: 3000, // 3 seconds
                  });
                //alert(`Error: ${errorMessages}`);
              } else if (error.request) {
                // Request was made but no response received
                toast.error(`No response from server. Please check your internet connection.`, {
                  autoClose: 3000, // 3 seconds
                });
              } else {
                // Other errors toast.error("Activity details not found! Please try again.", {
                  
                //alert("An error occurred while making the request.");
              }
             
            })
      
      } else {
        navigate("/login")
      } /*  */
      
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }
useEffect(() => {
  fetchSummativeListData()
}, [])

const [openSummativeItems, setOpenSummativeItems] = useState(
  Array(summativeActivity.length).fill(true)
)
// Function to toggle the open/close state of a specific item in summative
const toggleSummativeItem = index => {
  const newOpenItems = [...openSummativeItems]
  newOpenItems[index] = !newOpenItems[index]
  setOpenSummativeItems(newOpenItems)
}
const groupItemsBySubjectSummative = items => {
  return items.reduce((acc, item) => {
    const subject = item.subjectId || null
    if(subject){
      if (!acc[subject]) acc[subject] = []
      acc[subject].push(item)
    }
    return acc
  }, {})
}

const [activeSummativeIndex, setactiveSummativeIndex] = useState(null)

  const togglesummativeAccordion = index => {
    setactiveSummativeIndex(activeSummativeIndex === index ? null : index)
  }
  

  //delete modal for summative
  const [isDeleteSubmitting, setIsDeleteSubmitting] = useState(false)
  const [modal_summative, setmodal_summative] = useState(false)
  const tog_summative = () => {
    setmodal_summative(!modal_summative)
  }
const [deleteSummativedata, setDeleteSummativedata] = useState(null);
const fetchSummativeDeleteData = async () => {
  setIsDeleteSubmitting(true)
  try {
   
    if (getAuthToken() && getAuthToken() != "" && getAuthToken() != null) {
      
        axios.defaults.headers.common["Authorization"] = `Bearer ${getAuthToken()}`
        const responseSummativeDelete = await axios.post(LCMS_API_BASE_URL + "summative/delete", {
            activityId:deleteSummativedata,
            tutorKey: getEffectiveTutorKey()
          }).then(responseSummativeDelete => {
            setIsDeleteSubmitting(false)
            if (responseSummativeDelete?.status === 201) {
              setmodal_summative(false)
              toast.success("Summative activity details deleted.", {
                autoClose: 3000, // 3 seconds
              });
              fetchSummativeListData();
            } else {
              toast.error("Failed to delete summative activity details. Please try again.", {
                autoClose: 3000, // 3 seconds
              });
            }
           
          })
          .catch(error => {
            setIsDeleteSubmitting(false)
            console.error("Error fetching options from API: ", error);
             // Not process the logout because tutor api working fine continue process.

              // if (
              //   (error?.response?.status === 403 || error?.response?.status === 401) &&
              //   (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
              // ) {
              //   localStorage.clear()
              //   navigate("/login")
              // }
            // Handle API error response
            if (error.response) {
              // Server responded with a status other than 2xx
              const errorMessages = error?.response?.data?.errors
                ? error?.response?.data?.errors.map(err => err.message).join("\n")
                : "An error occurred. Please try again.";
                toast.error(`Error: ${errorMessages}`, {
                  autoClose: 3000, // 3 seconds
                });
              //alert(`Error: ${errorMessages}`);
            } else if (error.request) {
              // Request was made but no response received
              toast.error(`No response from server. Please check your internet connection.`, {
                autoClose: 3000, // 3 seconds
              });
            } else {
              // Other errors toast.error("Activity details not found! Please try again.", {
                
              //alert("An error occurred while making the request.");
            }
           
          })
    
    } else {
      navigate("/login")
    } /*  */
    
  } catch (error) {
    console.error("Error fetching data:", error)
  }
}


  // preview for Summitive start
    const [subjectIdData, setSubjectIdData] = useState(1)
  const [showPrevPopup, setShowPrevPopup] = useState(false)
  const [previewSummativeDetails, setpreviewSummativeDetails] = useState(null)
  const [popupPreviewSummativeData, setpopupPreviewSummativeData] = useState([])
  const [customActiveTab1, setcustomActiveTab1] = useState('0')
  const tog_PreviewSummative = () => {
    setcustomActiveTab1('0')
    setpopupPreviewSummativeData([])
    setShowPrevPopup(!showPrevPopup)
  }
  function toggleCustom1(tab) {
    if (customActiveTab1 !== tab) {
      setcustomActiveTab1(tab)
    }
  }


  function rearrangeEvenOddSecond(array) {
    const even = [] // To store even-indexed elements
    const odd = [] // To store odd-indexed elements

    array.forEach((element, index) => {
      if (index % 2 === 0) {
        even.push(element)
      } else {
        odd.push(element)
      }
    })

    // Combine odd and even arrays
    const rearranged = [...odd, ...even]

    return rearranged // Return the final rearranged array
  }

  function rearrangeEvenOdd(array) {
    array.sort((a, b) => {
      const textA = a.english_answer_text || a.answer_text || "";
      const textB = b.english_answer_text || b.answer_text || "";
      return textA.localeCompare(textB);
    });
    const even = [] // To store even-indexed elements
    const odd = [] // To store odd-indexed elements

    array.forEach((element, index) => {
      if (index % 2 === 0) {
        even.push(element)
      } else {
        odd.push(element)
      }
    })

    // Combine odd and even arrays
    const rearranged = [...odd, ...even]

    // Check if further rearrangement is needed
    if (rearranged.length > 1) {
      return rearrangeEvenOddSecond(rearranged) // Call recursively for further rearrangement
    }

    return rearranged // Return the final rearranged array
  }

  const goToNextTab = () => {
    const currentIndex = parseInt(customActiveTab1)
    if (subjectIdData === 1) {
      if (
        currentIndex <
        popupPreviewSummativeData.length - 1
      ) {
        toggleCustom1((currentIndex + 1).toString())
      }
    } else if (subjectIdData === 2) {
      if (
        currentIndex <
        popupPreviewSummativeData.length - 1
      ) {
        toggleCustom1((currentIndex + 1).toString())
      }
    }
  }
 
  const goToPrevTab = () => {
    const currentIndex = parseInt(customActiveTab1)
    if (currentIndex > 0) {
      toggleCustom1((currentIndex - 1).toString())
    }
  }
  const CountTotalCoinsForActivity = activityData => {
    let total_coins_stu = 0
  
  
    if (
      activityData &&  activityData.length > 0
    ) {
     
        activityData.forEach(lsquestion => {
            let questionData = lsquestion?.question_details || null;
            if (
              parseInt(lsquestion.subjectId) === 2 &&
              questionData
            ) {
                
              total_coins_stu += questionData?.question_parts?.length * 2 || 0
              
            } else if (
              parseInt(lsquestion.subjectId) === 1 &&
              questionData 
            ) {
              // lsquestion.english_question.forEach(lsquestionParts => {
                if (
                  parseInt(questionData?.english_question_category_id) ===
                    10 ||
                  parseInt(questionData?.english_question_category_id) === 13
                ) {
                  let total_part = questionData.question_parts
                  let array_part_data = total_part.filter(
                    part =>
                      part.question_answers.length > 0 &&
                      part.question_answers[0].english_answer_text &&
                      part.question_answers[0].english_answer_text != ""
                  )
                  total_coins_stu += array_part_data.length * 2 || 0
                } else {
                  total_coins_stu +=
                  questionData.question_parts.length * 2
                }
                // total_coins_stu += lsquestionParts.english_question_parts.length * 2;
              // })
            }
          })
       
    }
  
    return total_coins_stu;
  }


  const fetchpreviewSummativeData = async (data) => {
      //console.log(nodeId);
      if (getAuthToken() && getAuthToken() != "" && getAuthToken() != null) {
        try {
          setSubjectIdData(data.subjectId)
          setpreviewSummativeDetails(data)
          axios.defaults.headers.common["Authorization"] = `Bearer ${getAuthToken()}`
          const responseListLibrary = await axios.post(
            BASE_URL + "activity/getPreviewSummitiveDetails",
            { 
              questionWithData: data.questions
            }
          )
          const activitiesData = responseListLibrary.data.data       
  
          setpopupPreviewSummativeData(activitiesData)
  
          setShowPrevPopup(true)
  
      
        } catch (error) {
          console.error("Error in fetching List Library deatails:", error)
          //setLoader(false)
        }
      } else {
        navigate("/login")
      }
  }

//Summative end

  //pdf converter start
    const pdfRef = useRef();
    const [currentActivity, setCurrentActivity] = useState(null);
      const [isDownloading, setIsDownloading] = useState(false);
    
     const handleDownload = (activity) => {
        setIsDownloading(true);  
      setCurrentActivity(activity); // Set data
      setTimeout(() => {
        pdfRef.current?.generatePDF().finally(() => {
        setIsDownloading(false);       
        });
      }, 100); // Slight delay to ensure rendering
    };
    //pdf converter end
  return (
    <React.Fragment>
      <ToastContainer />

      <div className="page-content">
        <Container fluid>
          {adminMode ? (
            <div className="alert alert-info py-3 mb-3">
              {adminViewName ? (
                <span>
                  Acting as <strong>{adminViewName}</strong>.{" "}
                  <Link to="/dashboard">Change tutor on Home</Link>
                </span>
              ) : (
                <span>
                  Select a tutor on <Link to="/dashboard">Home</Link> to view and manage their library.
                </span>
              )}
            </div>
          ) : null}

          <div
            style={{
              backgroundColor: '#007bff', // same as Clear Filter
              color: '#ffffff',
              fontWeight: 'bold',
              padding: '10px 15px',
              borderRadius: '4px',
              marginBottom: '15px',
              textAlign: 'center'
            }}
          >
            NO COPYRIGHTED MATERIALS SHOULD BE UPLOADED HERE PLEASE. UPLOAD OF LINKS ARE ACCEPTABLE
          </div>
          <div className="page-title-box">
            <div>
              <div className="d-flex align-items-center">
                <div className="short-ic" onClick={() => window.history.back()}>
                  <img className="bc-bg2 mr-30" src={chevleft} />
                </div>

                <div>
                  <h6
                    className="page-title inner-pg-title mb-0"
                    style={{ width: "20vw" }}
                  >
                    {" "}
                    My Library
                  </h6>
                </div>
              </div>
            </div>
            <div className="custom-pg_header justify-content-between mb-3 align-items-center pdt-15">
              <div className="filter-section filter-libary pymts d-flex gap-3 mt-0">
                <form className="app-search page-search mylibary">
                  <div className="position-relative">
                    <span className="ion ion-ios-search"></span>
                    <input
                      type="text"
                      className="form-control"
                      value={filterValue}
                      placeholder={"Search for Activity Name..."}
                      onChange={handleFilter}
                    />
                  </div>
                </form>
                <div className="filter-child">
                  <DateRangePicker
                    format="dd-MM-yyyy"
                    value={dateValue}
                    onChange={handleDateChange}
                    cleanable={false}
                    weekStart={userSetting.calendarInput.firstDay}
                  />
                </div>
                <div className="filter-child">
                  <Button className="p-2" color="primary" onClick={filterReset}>
                    Clear Filter
                  </Button>
                </div>
              </div>

              {/* <form className="app-search page-search">
                <div className="position-relative">
                  <span className="fa fa-search"></span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={props.t("Search for activity name") + "..."}
                  />
                </div>
              </form> */}
              <div className="cts-btn-danger me-2" onClick={handle_summative}>
                Create Summative Activity
              </div>
              <div className="cts-btn-danger me-2" onClick={tog_large}>
                Add New Activity
              </div>
              <div className="cts-btn-danger me-2" onClick={() => {navigate("/my-library-share")}}>
               Share With Other Tutors
              </div>
              

              <Modal isOpen={modal_large} toggle={tog_large} size="lg">
                <ModalHeader className="mt-0" toggle={tog_large}>
                  Add New Activity
                </ModalHeader>
                <ModalBody>
                  <Form
                    autoComplete="off"
                    onSubmit={handleSubmit}
                    ref={formRef}
                  >
                    <Row className="mb-3 g-3">
                      
                       <Col className="col-6">
                        <div className="">
                          <label
                            htmlFor="example-text-input"
                            className=" col-form-label"
                          >
                            Folder Name<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div className="">
                            <CreatableSelect
                              options={allFolderOptions}
                              onChange={handleFolderChange}
                              value={allFolderOptions.find(
                                option =>
                                  option.value &&
                                  values.act_folder &&
                                  option.value.toString() ===
                                    (values.act_folder.value || values.act_folder).toString()
                              )}
                              filterOption={(option, inputValue) => {
                                const label = option?.label || '';
                                return label.toLowerCase().includes(inputValue.toLowerCase());
                              }}
                              placeholder="Select or create..."
                            />
                            {errors.act_folder && touched.act_folder && (
                              <p className="error">{errors.act_folder}</p>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col className="col-6">
                        <div className="">
                          <label
                            htmlFor="example-text-input"
                            className="col-form-label"
                          >
                            Subject<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div className="">
                            <Select
                              menuPlacement="auto"
                              options={subjectdata}
                              name="act_subject"
                              value={subjectdata.find(
                                option =>
                                  option.value &&
                                  values.act_subject &&
                                  option.value.toString() ===
                                    values.act_subject.toString()
                              )}
                              id="act_subject"
                              onChange={selectedOption => {
                                const event = {
                                  target: {
                                    name: "act_subject",
                                    value: selectedOption["value"],
                                  },
                                }
                                handleChange(event)
                                handleInputChange(event)
                              }}
                              onBlur={event => {
                                handleBlur(event)
                                setTouched({ ...touched, act_subject: true })
                              }}
                              className={
                                errors.act_subject && touched.act_subject
                                  ? "input-error"
                                  : ""
                              }
                            />
                            {errors.act_subject && touched.act_subject && (
                              <p className="error">{errors.act_subject}</p>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col className="col-6">
                        <div className="">
                          <label
                            htmlFor="example-text-input"
                            className=" col-form-label"
                          >
                            Activity type<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div className="">
                            <Select
                              menuPlacement="auto"
                              options={optionGroup3}
                              name="act_type"
                              value={optionGroup3.find(
                                option =>
                                  option.value &&
                                  values.act_type &&
                                  option.value.toString() ===
                                    values.act_type.toString()
                              )}
                              id="act_type"
                              onChange={selectedOption => {
                                const event = {
                                  target: {
                                    name: "act_type",
                                    value: selectedOption["value"],
                                  },
                                }
                                handleChange(event)
                                handleInputChange(event)
                              }}
                              onBlur={event => {
                                handleBlur(event)
                                setTouched({ ...touched, act_type: true })
                              }}
                              className={
                                errors.act_type && touched.act_type
                                  ? "input-error"
                                  : ""
                              }
                            />
                            {errors.act_type && touched.act_type && (
                              <p className="error">{errors.act_type}</p>
                            )}
                          </div>
                        </div>
                      </Col>

                      <Col className="col-6">
                        <div className="">
                          <label
                            htmlFor="example-text-input"
                            className="col-form-label"
                          >
                            Activity name<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div className="">
                            <Input
                              type="text"
                              value={values.act_name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              id="act_name"
                              className={
                                errors.act_name && touched.act_name
                                  ? "form-control input-error"
                                  : ""
                              }
                            />
                            {errors.act_name && touched.act_name && (
                              <p className="error">{errors.act_name}</p>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col className="col-6">
                        <div className="">
                          <label
                            htmlFor="example-text-input"
                            className="col-form-label"
                          >
                            Source<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div className="">
                            <Input
                              type="text"
                              value={values.act_source}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              id="act_source"
                              className={
                                errors.act_source && touched.act_source
                                  ? "form-control input-error"
                                  : ""
                              }
                            />
                            {errors.act_source && touched.act_source && (
                              <p className="error">{errors.act_source}</p>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col className="col-12">
                        <div className="">
                          <label
                            htmlFor="example-text-input"
                            className="col-form-label"
                          >
                            Description
                          </label>
                          <div className="">
                            <textarea
                              id={`act_description`}
                              
                              placeholder=""
                              value={values.act_description}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              rows="4"
                              className={
                                errors.act_description && touched.act_description
                                  ? "form-control input-error"
                                  : "form-control"
                              }
                            />
                            
                            {errors.act_description && touched.act_description && (
                              <p className="error">{errors.act_description}</p>
                            )}
                          </div>
                        </div>
                      </Col>
                      
                      <Col className="col-6">
                        <div className="">
                          <label
                            htmlFor="example-text-input"
                            className="col-form-label"
                          >
                            Duration<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div className="">
                            <Select
                              menuPlacement="auto"
                              options={optionGroup4}
                              name="act_duration"
                              value={optionGroup4.find(
                                option =>
                                  option.value &&
                                  values.act_duration &&
                                  option.value.toString() ===
                                    values.act_duration.toString()
                              )}
                              id="act_duration"
                              onChange={selectedOption => {
                                const event = {
                                  target: {
                                    name: "act_duration",
                                    value: selectedOption["value"],
                                  },
                                }
                                handleChange(event)
                              }}
                              onBlur={event => {
                                handleBlur(event)
                                setTouched({ ...touched, act_duration: true })
                              }}
                              className={
                                errors.act_duration && touched.act_duration
                                  ? "input-error"
                                  : ""
                              }
                            />
                            {errors.act_duration && touched.act_duration && (
                              <p className="error">{errors.act_duration}</p>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col className="col-6">
                        <div className="">
                          <label
                            htmlFor="example-text-input"
                            className="col-form-label"
                          >
                            Coins<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div className="">
                            <Select
                              menuPlacement="auto"
                              options={optionCoin}
                              name="act_coin"
                              value={optionCoin.find(
                                option =>
                                  option.value &&
                                  values.act_coin &&
                                  option.value.toString() ===
                                    values.act_coin.toString()
                              )}
                              id="act_coin"
                              onChange={selectedOption => {
                                const event = {
                                  target: {
                                    name: "act_coin",
                                    value: selectedOption["value"],
                                  },
                                }
                                handleChange(event)
                              }}
                              onBlur={event => {
                                handleBlur(event)
                                setTouched({ ...touched, act_coin: true })
                              }}
                              className={
                                errors.act_coin && touched.act_coin
                                  ? "input-error"
                                  : ""
                              }
                            />
                            {errors.act_coin && touched.act_coin && (
                              <p className="error">{errors.act_coin}</p>
                            )}
                          </div>
                        </div>
                      </Col>


                      {selectedOption3 === "1" && (
                        <Col className="col-6">
                          <div className="">
                            <label
                              htmlFor="example-text-input"
                              className="col-form-label"
                            >
                              Video<span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="">
                              <Input
                                type="text"
                                value={values.act_video}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                id="act_video"
                                className={
                                  errors.act_video && touched.act_video
                                    ? "form-control input-error"
                                    : ""
                                }
                              />
                              {errors.act_video && touched.act_video && (
                                <p className="error">{errors.act_video}</p>
                              )}
                            </div>
                          </div>
                        </Col>
                      )}
                      {selectedOption3 === "3" && (
                        <Col className="col-6">
                          <div className="">
                            <label
                              htmlFor="example-text-input"
                              className="col-form-label"
                            >
                              Link<span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="">
                              <Input
                                type="text"
                                value={values.act_link}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                id="act_link"
                                className={
                                  errors.act_link && touched.act_link
                                    ? "form-control input-error"
                                    : ""
                                }
                              />
                              {errors.act_link && touched.act_link && (
                                <p className="error">{errors.act_link}</p>
                              )}
                            </div>
                          </div>
                        </Col>
                      )}
                      {(selectedOption3 === "5" || selectedOption3 === "10") && (
                        <Col className="col-12">
                          <div className="">
                            <label
                              htmlFor="example-text-input"
                              className="col-form-label"
                            >
                              Upload {selectedOption3 === "10"? "File" : "PDF"}<span style={{ color: 'red' }}>*</span>
                            </label>

                            <span> File size should not exceed 50mb</span>
                            <div className="">
                              <Input
                                type="file"
                                accept={
                                  selectedOption3 === "10"
                                    ? ".pdf, .doc, .docx, .ppt, .pptx"
                                    : ".pdf"
                                }
                                onChange={event => {
                                  formik.setFieldValue(
                                    "act_file",
                                    event.currentTarget.files[0]
                                  )
                                }}
                                onBlur={handleBlur}
                                id="act_file"
                                name="act_file"
                                className={
                                  errors.act_file && touched.act_file
                                    ? "form-control input-error"
                                    : ""
                                }
                              />
                              {errors.act_file && touched.act_file && (
                                <p className="error">{errors.act_file}</p>
                              )}
                            </div>
                          </div>
                        </Col>
                      )}
                      {/* {selectedOption === 'Date' && (
   <input
     type="date"
     value={inputValue}
     onChange={handleInputValueChange}
     placeholder="Select date..."
   />
 )} */}
                    </Row>
                    <div className="text-end mt-4">
                      {/* <Button type="submit" color="danger">
                        Add
                      </Button> */}
                      <Button
                        type="submit"
                        variant="contained"
                        color="danger"
                        disabled={isSubmitting}
                      >
                        Add
                      </Button>
                    </div>
                  </Form>
                </ModalBody>
              </Modal>

              <Modal isOpen={modal_large1} toggle={tog_large1} size="lg">
                <ModalHeader className="mt-0" toggle={tog_large1}>
                  Edit New Activity
                </ModalHeader>
                <ModalBody>
                  <Form
                    autoComplete="off"
                    onSubmit={handleSubmit1}
                    ref={formRef}
                  >
                    <Row className="mb-3 g-3">
                      <Col className="col-6">
                        <div className="">
                          <label
                            htmlFor="example-text-input"
                            className=" col-form-label"
                          >
                            Folder Name<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div className="">
                            <CreatableSelect
                              options={allFolderOptions}
                              onChange={handleUpdateFolderChange}
                              value={allFolderOptions.find(
                                option =>
                                  option.value &&
                                  values1.act_folder &&
                                  option.value.toString() ===
                                  (values1.act_folder.value || values1.act_folder).toString()
                              )}
                              filterOption={(option, inputValue) => {
                                const label = option?.label || '';
                                return label.toLowerCase().includes(inputValue.toLowerCase());
                              }}
                              placeholder="Select or create..."
                            />
                            {errors1.act_folder && touched1.act_folder && (
                              <p className="error">{errors1.act_folder}</p>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col className="col-6">
                        <div className="">
                          <label
                            htmlFor="example-text-input"
                            className="col-form-label"
                          >
                            Subject<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div className="">
                            <Select
                              menuPlacement="auto"
                              options={subjectdata}
                              name="act_subject"
                              value={subjectdata.find(
                                option =>
                                  option.value &&
                                  values1.act_subject &&
                                  option.value.toString() ===
                                    values1.act_subject.toString()
                              )}
                              id="act_subject"
                              onChange={selectedOption => {
                                const event = {
                                  target: {
                                    name: "act_subject",
                                    value: selectedOption["value"],
                                  },
                                }
                                handleChange1(event)
                              }}
                              onBlur={event => {
                                handleBlur1(event)
                                setTouched1({ ...touched1, act_subject: true })
                              }}
                              className={
                                errors1.act_subject && touched1.act_subject
                                  ? "input-error"
                                  : ""
                              }
                            />
                            {errors1.act_subject && touched1.act_subject && (
                              <p className="error">{errors1.act_subject}</p>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col className="col-6">
                        <div className="">
                          <label
                            htmlFor="example-text-input"
                            className=" col-form-label"
                          >
                            Activity type<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div className="">
                            {/* <Select
                              menuPlacement="auto"
                              options={optionGroup3}
                              name="act_type"
                              value={optionGroup3.find(options => options.value === values1.act_type)}
                              id="act_type"
                              onChange={(selectedOption) => {
                                const event = {
                                  target: {
                                    name: "act_type",
                                    value: selectedOption ? selectedOption.value : "", // Ensure a valid value is set
                                  },
                                };
                                handleChange1(event);
                              }}
                              onBlur={(event) => {
                                handleBlur1(event);
                                setTouched1({ ...touched1, act_type: true });
                              }}
                              className={errors1.act_type && touched1.act_type ? "input-error" : ""}
                            /> */}

                            <Select
                              menuPlacement="auto"
                              options={optionGroupedit3}
                              name="act_type"
                              value={optionGroupedit3.find(
                                option =>
                                  option.value &&
                                  values1.act_type &&
                                  option.value.toString() ===
                                    values1.act_type.toString()
                              )}
                              id="act_type"
                              onChange={selectedOption => {
                                const selectedValue = selectedOption
                                  ? selectedOption.value
                                  : "" // Ensure a valid value is set
                                const event = {
                                  target: {
                                    name: "act_type",
                                    value: selectedValue,
                                  },
                                }

                                // Check the selected value and set a specific value based on a condition
                                let newValue = selectedValue // Default to the selected value
                                if (selectedValue === "desiredValue") {
                                  // Change 'desiredValue' to your condition
                                  newValue = "newValue" // Set the new value based on the condition
                                }

                                // Set the new value before calling handleInputChangeEdit
                                event.target.value = newValue
                                handleChange1(event)

                                handleInputChangeEdit(event)
                              }}
                              onBlur={event => {
                                handleBlur1(event)
                                setTouched1({ ...touched1, act_type: true })
                              }}
                              className={
                                errors1.act_type && touched1.act_type
                                  ? "input-error"
                                  : ""
                              }
                            />
                            {/* <Select
                              menuPlacement="auto" options={optionGroup3}
                              name="act_type"
                              value={optionGroup3.find(options => options.value && values1.act_type && options.value == values1.act_type)}
                              id="act_type"
                              onChange={(selectedOption) => {
                                const event = {
                                  target: {
                                    name: "act_type",
                                    value: selectedOption["value"],
                                  },
                                };
                                handleChange1(event);
                              }}
                              onBlur={(event) => {
                                handleBlur1(event);
                                setTouched1({ ...touched1, act_type: true });
                              }}
                              className={errors1.act_type && touched1.act_type ? "input-error" : ""}
                            /> */}
                            {errors1.act_type && touched1.act_type && (
                              <p className="error">{errors1.act_type}</p>
                            )}
                          </div>
                        </div>
                      </Col>

                      <Col className="col-6">
                        <div className="">
                          <label
                            htmlFor="example-text-input"
                            className="col-form-label"
                          >
                            Activity name<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div className="">
                            <Input
                              type="text"
                              value={values1.act_name}
                              onChange={handleChange1}
                              onBlur={handleBlur1}
                              id="act_name"
                              className={
                                errors1.act_name && touched1.act_name
                                  ? "form-control input-error"
                                  : ""
                              }
                            />
                            {errors1.act_name && touched1.act_name && (
                              <p className="error">{errors1.act_name}</p>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col className="col-6">
                        <div className="">
                          <label
                            htmlFor="example-text-input"
                            className="col-form-label"
                          >
                            Source<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div className="">
                            <Input
                              type="text"
                              value={values1.act_source}
                              onChange={handleChange1}
                              onBlur={handleBlur1}
                              id="act_source"
                              className={
                                errors1.act_source && touched1.act_source
                                  ? "form-control input-error"
                                  : ""
                              }
                            />
                            {errors1.act_source && touched1.act_source && (
                              <p className="error">{errors1.act_source}</p>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col className="col-12">
                        <div className="">
                          <label
                            htmlFor="example-text-input"
                            className="col-form-label"
                          >
                            Description
                          </label>
                          <div className="">
                            <textarea
                              id={`act_description`}
                              
                              placeholder=""
                              value={values1.act_description}
                              onChange={handleChange1}
                              onBlur={handleBlur1}
                              rows="4"
                              className={
                                errors1.act_description && touched1.act_description
                                  ? "form-control input-error"
                                  : "form-control"
                              }
                            />
                            
                            {errors1.act_description && touched1.act_description && (
                              <p className="error">{errors1.act_description}</p>
                            )}
                          </div>
                        </div>
                      </Col>

                      <Col className="col-6">
                        <div className="">
                          <label
                            htmlFor="example-text-input"
                            className="col-form-label"
                          >
                            Duration<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div className="">
                            <Select
                              menuPlacement="auto"
                              options={optionGroup4}
                              name="act_duration"
                              value={optionGroup4.find(
                                option =>
                                  option.value &&
                                  values1.act_duration &&
                                  option.value.toString() ===
                                    values1.act_duration.toString()
                              )}
                              id="act_duration"
                              onChange={selectedOption => {
                                const event = {
                                  target: {
                                    name: "act_duration",
                                    value: selectedOption["value"],
                                  },
                                }
                                handleChange1(event)
                              }}
                              onBlur={event => {
                                handleBlur1(event)
                                setTouched1({ ...touched1, act_duration: true })
                              }}
                              className={
                                errors1.act_duration && touched1.act_duration
                                  ? "input-error"
                                  : ""
                              }
                            />
                            {errors1.act_duration && touched1.act_duration && (
                              <p className="error">{errors1.act_duration}</p>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col className="col-6">
                        <div className="">
                          <label
                            htmlFor="example-text-input"
                            className="col-form-label"
                          >
                            Coins<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div className="">
                            <Select
                              menuPlacement="auto"
                              options={optionCoin}
                              name="act_coin"
                              value={optionCoin.find(
                                option =>
                                  option.value &&
                                  values1.act_coin &&
                                  option.value.toString() ===
                                    values1.act_coin.toString()
                              )}
                              id="act_coin"
                              onChange={selectedOption => {
                                const event = {
                                  target: {
                                    name: "act_coin",
                                    value: selectedOption["value"],
                                  },
                                }
                                handleChange1(event)
                              }}
                              onBlur={event => {
                                handleBlur1(event)
                                setTouched1({ ...touched1, act_coin: true })
                              }}
                              className={
                                errors1.act_coin && touched1.act_coin
                                  ? "input-error"
                                  : ""
                              }
                            />
                            {errors1.act_coin && touched1.act_coin && (
                              <p className="error">{errors1.act_coin}</p>
                            )}
                          </div>
                        </div>
                      </Col>
                      {console.log("tyr", selectedOption3edit)}
                      {selectedOption3edit === 1 && (
                        <Col className="col-6">
                          <div className="">
                            <label
                              htmlFor="example-text-input"
                              className="col-form-label"
                            >
                              Video<span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="">
                              <Input
                                type="text"
                                value={values1.act_video || ""}
                                onChange={handleChange1}
                                onBlur={handleBlur1}
                                id="act_video"
                                className={
                                  errors1.act_video && touched1.act_video
                                    ? "form-control input-error"
                                    : ""
                                }
                              />
                              {errors1.act_video && touched1.act_video && (
                                <p className="error">{errors1.act_video}</p>
                              )}
                            </div>
                          </div>
                        </Col>
                      )}
                      {selectedOption3edit === 3 && (
                        <Col className="col-6">
                          <div className="">
                            <label
                              htmlFor="example-text-input"
                              className="col-form-label"
                            >
                              Link<span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="">
                              <Input
                                type="text"
                                value={values1.act_link || ""}
                                onChange={handleChange1}
                                onBlur={handleBlur1}
                                id="act_link"
                                className={
                                  errors1.act_link && touched1.act_link
                                    ? "form-control input-error"
                                    : ""
                                }
                              />
                              {errors1.act_link && touched1.act_link && (
                                <p className="error">{errors1.act_link}</p>
                              )}
                            </div>
                          </div>
                        </Col>
                      )}
                      {/* {selectedOption3edit === 5 && (
                        <Col className="col-12">
                          <div className="">
                            <label
                              htmlFor="example-text-input"
                              className="col-form-label"
                            >
                              Upload PDF
                            </label>

                            <span> File size should not exceed 2mb</span>
                            <div className="">
                              <Input
                                type="file"
                                accept=".pdf"
                                onChange={event => {
                                  formik1.setFieldValue(
                                    "act_file",
                                    event.currentTarget.files[0]
                                  )
                                }}
                                onBlur={handleBlur}
                                id="act_file"
                                name="act_file"
                                className={
                                  errors1.act_file && touched1.act_file
                                    ? "form-control input-error"
                                    : ""
                                }
                              />
                            </div>
                          </div>
                        </Col>
                      )} */}
                      {(selectedOption3edit === 5 || selectedOption3edit === 10) && (
                        <div className="">
                          {values1.act_file1 ? (
                            <div>
                              <label
                                htmlFor="example-text-input"
                                className="col-form-label"
                              >
                                Uploaded {selectedOption3edit === 10? "File" : "PDF"}<span style={{ color: 'red' }}>*</span>
                              </label>
                              <div className="uploaded-file-info">
                                <span>{values1.act_file1}</span>
                                <button
                                  type="button"
                                  onClick={handleRemoveFile}
                                  className="close-icon"
                                >
                                  &times; {/* Close icon */}
                                </button>
                              </div>
                            </div>
                          ) : (
                            <Col className="col-12">
                              <div className="">
                                <label
                                  htmlFor="example-text-input"
                                  className="col-form-label"
                                >
                                  Upload {selectedOption3edit === 10? "File" : "PDF"}<span style={{ color: 'red' }}>*</span>
                                </label>

                                {/* <span> File size should not exceed 2mb</span> */}
                                <div className="">
                                  <Input
                                    type="file"
                                    accept={
                                      selectedOption3edit === 10
                                        ? ".pdf, .doc, .docx, .ppt, .pptx"
                                        : ".pdf"
                                    }
                                    onChange={event => {
                                      formik1.setFieldValue(
                                        "act_file",
                                        event.currentTarget.files[0]
                                      )
                                    }}
                                    onBlur={handleBlur1}
                                    id="act_file"
                                    name="act_file"
                                    className={
                                      errors1.act_file && touched1.act_file
                                        ? "form-control input-error"
                                        : ""
                                    }
                                  />
                                  {errors1.act_file && touched1.act_file && (
                                    <p className="error">{errors1.act_file}</p>
                                  )}
                                </div>
                              </div>
                            </Col>
                          )}
                        </div>
                      )}
                    </Row>
                    <div className="text-end mt-4">
                      {/* <Button type="submit" color="danger">
                        Add
                      </Button> */}
                      <Button
                        type="submit"
                        variant="contained"
                        color="danger"
                        disabled={isSubmitting1}
                      >
                        Edit
                      </Button>
                    </div>
                  </Form>
                </ModalBody>
              </Modal>

              <Modal isOpen={modal_center} toggle={tog_center} centered>
                <ModalBody className="delete-pp text-center">
                  <div className="mm-icon text-danger">
                    <i className="fas fa-exclamation-circle"></i>
                  </div>
                  <h5>Delete Confirmation</h5>
                  <p>Are you sure you want to delete this activity?</p>

                  <div className="btn-group mt-4">
                    <Button
                      className="btn-md me-2"
                      color="danger"
                      disabled={isUserDeleteSubmitting}
                      onClick={() => onSubmitUserDelete()}
                    >
                      Yes
                    </Button>

                    <Button
                      className="btn-md btn-outline-danger"
                      color=""
                      onClick={() => setmodal_center(false)}
                    >
                      Cancel
                    </Button>
                  </div>
                </ModalBody>
              </Modal>

              <Modal isOpen={modal_summative} toggle={tog_summative} centered>
                <ModalBody className="delete-pp text-center">
                  <div className="mm-icon text-danger">
                    <i className="fas fa-exclamation-circle"></i>
                  </div>
                  <h5>Delete Confirmation</h5>
                  <p>Are you sure you want to delete this activity?</p>

                  <div className="btn-group mt-4">
                    <Button
                      className="btn-md me-2"
                      color="danger"
                      disabled={isDeleteSubmitting}
                      onClick={() => fetchSummativeDeleteData()}
                    >
                      Yes
                    </Button>

                    <Button
                      className="btn-md btn-outline-danger"
                      color=""
                      onClick={() => setmodal_summative(false)}
                    >
                      Cancel
                    </Button>
                  </div>
                </ModalBody>
              </Modal>

               <Modal
                isOpen={showPrevPopup}
                toggle={tog_PreviewSummative}
                size="xl"
              >
                <MathJax inline dynamic>
                  {Object.keys(popupPreviewSummativeData).length > 0 ? (
                    <>
                      <ModalHeader
                        className="mt-0 preview-activity"
                        toggle={tog_PreviewSummative}
                        style={{ backgroundColor: "#20365b" }}
                      >
                        <div className="d-flex align-items-center justify-content-between w-90">
                          <h6 className="mb-0 font-size-20 text-white w-60 fw-500">
                          {previewSummativeDetails.name}
                          </h6>
                          <div className="d-flex align-items-center gap-4">
                            {/* <p className="mb-0 text-uppercase luminous-wht">
                              {" "}
                              <span className="text-yellow me-1">
                                {sessionStudentData && sessionStudentData != ""
                                  ? getUniqueSubjectNames(sessionStudentData).join(
                                      " & "
                                    ) || "-"
                                  : "-"}
                              </span><br></br>{" "}
                            </p> */}
                            <div className="luminous-wht font-size-16">
                              <img width={24} className="" src={awicon} alt="" /> 0 /{" "}
                              {popupPreviewSummativeData &&
                              popupPreviewSummativeData.length > 0 ? CountTotalCoinsForActivity(popupPreviewSummativeData) : 0}{" "}
                              coins earned
                            </div>
                          </div>
                        </div>
                      </ModalHeader>
                      <ModalBody>
                        {subjectIdData === 1 && (
                          <Container className="custom-wt">
                            <div className="assessement-section assessment-width-hold">
                               <div style={{display: localStorage.getItem("is_trial") == '1' ? "none" : ""}}>
                                  <div className="d-flex justify-content-end me-3">
                                    {/* <span onClick={() => handleDownload(popupPreviewSummativeData)}><i className="mdi mdi-file-pdf-box" style={{fontSize: "30px"}}></i></span> */}
                                     {isDownloading ? (
                                        <div className="spinner-border text-primary" role="status" style={{ width: "30px", height: "30px" }}>
                                          <span className="visually-hidden">Loading...</span>
                                        </div>
                                      ) : (
                                        <span onClick={() => handleDownload(popupPreviewSummativeData)}>
                                          <i className="mdi mdi-file-pdf-box" style={{ fontSize: "30px" }}></i>
                                        </span>
                                      )}
                                  </div>
                                  
                                  <ActivityToPDFConverter ref={pdfRef} ActivityData={currentActivity} type='SummativePopup' name={previewSummativeDetails.name} />
                                </div>
                              <Nav tabs className="md-prev-tab mb-3">
                                {
                                  // popupPreviewSummativeData && (subjectIdData === 1
                                  //   ? popupPreviewSummativeData.english_question_activities
                                  //   : subjectIdData === 2
                                  //     ? popupPreviewSummativeData.question_activities
                                  //     : []
                                  // ).map((activity, popactivityindex) => (
                                  popupPreviewSummativeData &&
                                    popupPreviewSummativeData.length > 0 &&
                                    popupPreviewSummativeData.map(
                                      (activity, popactivityindex) => (
                                        <NavItem key={popactivityindex}>
                                          <NavLink
                                            style={{ cursor: "pointer", border: "unset" }}
                                            className={
                                              classnames({
                                                active:
                                                  customActiveTab1 ===
                                                  popactivityindex.toString(),
                                              }) + " display-number"
                                            }
                                            onClick={() =>
                                              toggleCustom1(
                                                popactivityindex.toString()
                                              )
                                            }
                                          >
                                            <span className="font-size-20 fw-800">
                                              {popactivityindex + 1}
                                            </span>
                                          </NavLink>
                                        </NavItem>
                                      )
                                    )
                                }
                              </Nav>
    
                              <TabContent
                                activeTab={customActiveTab1}
                                className="text-muted question_container"
                              >
                                {popupPreviewSummativeData &&
                                  popupPreviewSummativeData.length > 0 &&
                                  popupPreviewSummativeData.map(
                                    (activity, popactivityindex) => (
                                      <TabPane
                                        tabId={popactivityindex.toString()}
                                        key={popactivityindex}
                                      >
                                        {" "}
                                        <div className="hw-list mt-4 pb-100">
                                        <div className={
                                            [8, 2, 12].includes(
                                              activity.question_details?.english_question_new_category?.english_question_category_id
                                            ) ? "question-container-custom"
                                              : ""
                                          }>
                                            <div className={
                                              [8, 2, 12].includes(
                                                activity.question_details?.english_question_new_category?.english_question_category_id
                                              )  ? "QuestionBody jss13 passage-area flex-fill border"
                                                : "QuestionBody jss13 mb-3"
                                            }>
                                              <div>
                                                <div
                                                  className="mt-3"
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      activity.question_details &&
                                                      activity.question_details
                                                        .english_question_instruction
                                                        ? activity.question_details &&
                                                          activity.question_details.english_question_instruction
                                                            .replace(
                                                              /\[(\d+)Answer char=\d+\]/g,
                                                              ""
                                                            )
                                                            .replace(
                                                              /\[Answer char=\d+\]/g,
                                                              ""
                                                            )
                                                        : null,
                                                  }}
                                                ></div>
      
                                                {activity.question_details &&
                                                activity.question_details
                                                  .english_question_choices &&
                                                activity.question_details
                                                  .english_question_choices.length >
                                                  0 ? (
                                                  <div className="mt-3 my-2 border border-dark choice-options_wrapper">
                                                    {activity.question_details.english_question_choices.map(
                                                      (qusChoice, Cindex) => (
                                                        <div
                                                          class="choice-options_child"
                                                          key={Cindex}
                                                        >
                                                          <div>
                                                            {qusChoice.choice_no}
                                                          </div>
                                                          <div>
                                                            {qusChoice.choice_text}
                                                          </div>
                                                        </div>
                                                      )
                                                    )}
                                                  </div>
                                                ) : null}
      
                                                {activity.question_details &&
                                                  activity.question_details
                                                    .english_question_new_category &&
                                                  activity.question_details
                                                    .english_question_new_category
                                                    .english_question_category_id ===
                                                    1 &&
                                                  (activity.question_details
                                                    .english_question_text ? (
                                                    <div
                                                      className="mt-3"
                                                      dangerouslySetInnerHTML={{
                                                        __html:
                                                          activity.question_details.english_question_text
                                                            .replace(
                                                              /\[(\d+)Answer char=\d+\]/g,
                                                              ""
                                                            )
                                                            .replace(
                                                              /\[Answer char=\d+\]/g,
                                                              ""
                                                            ),
                                                      }}
                                                    />
                                                  ) : null)}
                                                {activity.question_details &&
                                                  activity.question_details
                                                    .english_question_new_category &&
                                                  activity.question_details
                                                    .english_question_new_category
                                                    .english_question_category_id ===
                                                    2 &&
                                                  (activity.question_details
                                                    .english_question_text ? (
                                                    <div
                                                      className="mt-3"
                                                      dangerouslySetInnerHTML={{
                                                        __html:
                                                          activity.question_details.english_question_text
                                                            .replace(
                                                              /\[(\d+)Answer char=\d+\]/g,
                                                              ""
                                                            )
                                                            .replace(
                                                              /\[Answer char=\d+\]/g,
                                                              ""
                                                            ),
                                                      }}
                                                    />
                                                  ) : null)}
                                                {activity.question_details &&
                                                  activity.question_details
                                                    .english_question_new_category &&
                                                  activity.question_details
                                                    .english_question_new_category
                                                    .english_question_category_id ===
                                                    8 &&
                                                  (activity.question_details
                                                    .english_question_text ? (
                                                    <div
                                                      className="mt-4"
                                                      dangerouslySetInnerHTML={{
                                                        __html: activity
                                                          .question_details
                                                          .english_question_text
                                                          ? activity.question_details.english_question_text
                                                              .replace(
                                                                /\[(\d+)Answer char=\d+\]/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                /\[Answer char=\d+\]/g,
                                                                ""
                                                              )
                                                              .replace(/&nbsp;/g, "")
                                                              .split("</p>")
                                                              .map(
                                                                (paragraph, index) =>
                                                                  paragraph
                                                                    ? `<div class="d-flex mt-2"><p class="me-2">${
                                                                        index + 1
                                                                      } ${paragraph}</p></div>`
                                                                    : ""
                                                              )
                                                              .filter(Boolean)
                                                              .join("")
                                                          : null,
                                                      }}
                                                    />
                                                  ) : //  <div className="mt-3" dangerouslySetInnerHTML={{ __html: activity.english_question.english_question_text.replace(/\[(\d+)Answer char=\d+\]/g, '').replace(/\[Answer char=\d+\]/g, '') }} />
                                                  null)}
                                                {activity.question_details &&
                                                  activity.question_details
                                                    .english_question_new_category &&
                                                  (parseInt(
                                                    activity.question_details
                                                      .english_question_new_category
                                                      .english_question_category_id
                                                  ) === 10 ||
                                                    parseInt(
                                                      activity.question_details
                                                        .english_question_new_category
                                                        .english_question_category_id
                                                    ) === 13) &&
                                                  (activity.question_details
                                                    .english_question_text ? (
                                                    <div
                                                      className="mt-3"
                                                      dangerouslySetInnerHTML={{
                                                        __html:
                                                          activity.question_details.english_question_text
                                                            .replace(
                                                              /\[(\d+)Answer char=\d+\]/g,
                                                              ""
                                                            )
                                                            .replace(
                                                              /\[Answer char=\d+\]/g,
                                                              ""
                                                            ),
                                                      }}
                                                    />
                                                  ) : null)}
                                                {activity.question_details &&
                                                  activity.question_details
                                                    .english_question_new_category &&
                                                  (parseInt(
                                                    activity.question_details
                                                      .english_question_new_category
                                                      .english_question_category_id
                                                  ) === 10 ||
                                                    parseInt(
                                                      activity.question_details
                                                        .english_question_new_category
                                                        .english_question_category_id
                                                    ) === 13) &&
                                                  (activity.question_details
                                                    .part_heading ? (
                                                    <div
                                                      className="mt-3"
                                                      dangerouslySetInnerHTML={{
                                                        __html:
                                                          activity.question_details.part_heading
                                                            .replace(
                                                              /\[(\d+)Answer char=\d+\]/g,
                                                              ""
                                                            )
                                                            .replace(
                                                              /\[Answer char=\d+\]/g,
                                                              ""
                                                            ),
                                                      }}
                                                    />
                                                  ) : null)}
                                              </div>
                                            </div>
                                            <div className={
                                              [8, 2, 12].includes(
                                                activity.question_details?.english_question_new_category?.english_question_category_id
                                              )  ? "question-area flex-fill border"
                                                : ""
                                            }>
                                            {activity &&
                                              activity.question_details &&
                                              activity.question_details
                                                .question_parts &&
                                              activity.question_details
                                                .question_parts &&
                                              activity.question_details.question_parts.map(
                                                (
                                                  activityQuestion,
                                                  indexactivityQuestion
                                                ) => (
                                                  <>
      
                                                  
      
                                                    {activity.question_details &&
                                                      activity.question_details
                                                        .english_question_new_category &&
                                                      activity.question_details
                                                        .english_question_new_category
                                                        .english_question_category_id ==
                                                        1 && (
                                                        <ul className="dg-selector list-unstyled mb-0 pt-4">
                                                          {parseInt(activityQuestion.english_question_part_automark) === 0? <div className="d-flex justify-content-end mb-2"><div className="badge bg-primary text-white font-size-12 mb-0" style={{color: 'white'}}>Manual Marking</div></div> : null}
                                                          {activityQuestion &&
                                                            activityQuestion.question_answers &&
                                                            (() => {
                                                              let serialNumber = 0 // Initialize a separate counter for serial numbers
                                                              return rearrangeEvenOdd(
                                                                activityQuestion.question_answers
                                                              ).map(
                                                                (
                                                                  activityQuestionAns,
                                                                  indexQuestionAns
                                                                ) => {
                                                                  if (
                                                                    activityQuestionAns &&
                                                                    activityQuestionAns.english_answer_text
                                                                  ) {
      
                                                                    const cleanText = activityQuestionAns.english_answer_text
                                                                    .replace(/&nbsp;/g, '')
                                                                    .replace(/`/g, '')
                                                                    .replace(/<[^>]*>/g, '')
                                                                    .trim();
                  
                                                                      const hasImage = /<img\s+[^>]*>/gi.test(activityQuestionAns.english_answer_text);
                        
                                                                      if (!cleanText && !hasImage) {
                                                                          return null; // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                      }
                                                                    serialNumber++ // Increment serial number only when there's valid text
      
                                                                    return (
                                                                      <li
                                                                        key={
                                                                          indexQuestionAns
                                                                        }
                                                                        className={
                                                                          activityQuestionAns.english_answer_is_correct ==
                                                                          1
                                                                            ? "selector-display"
                                                                            : ""
                                                                        }
                                                                      >
                                                                        <div className="p-2 px-3 font-size-18">
                                                                          {
                                                                            serialNumber
                                                                          }
                                                                        </div>
                                                                        <div className="p-2 px-3 dg-media border-start-display">
                                                                          <div
                                                                            dangerouslySetInnerHTML={{
                                                                              __html:
                                                                                activityQuestionAns.english_answer_text,
                                                                            }}
                                                                          />
                                                                        </div>
                                                                      </li>
                                                                    )
                                                                  }
      
                                                                  return null // Skip rendering if there's no answer text
                                                                }
                                                              )
                                                            })()}
                                                        </ul>
                                                      )}
      
                                                    
                                                    {activity.question_details &&
                                                      activity.question_details
                                                        .english_question_new_category &&
                                                      activity.question_details
                                                        .english_question_new_category
                                                        .english_question_category_id ==
                                                        2 && (
                                                        <>
                                                          <div className="mr-3">
                                                            {indexactivityQuestion +
                                                              1}
                                                            {")"}
                                                          </div>
                                                          <ul className="dg-selector list-unstyled mb-0 pt-2">
                                                            {parseInt(activityQuestion.english_question_part_automark) === 0? <div className="d-flex justify-content-end mb-2"><div className="badge bg-primary text-white font-size-12 mb-0" style={{color: 'white'}}>Manual Marking</div></div> : null}
                                                            {activityQuestion &&
                                                              activityQuestion.question_answers &&
                                                              (() => {
                                                                let serialNumber = 0 // Separate counter for serial number
                                                                const answers = activityQuestion.english_question_part_answer_type === 4
                                                                                  ? rearrangeEvenOdd(activityQuestion.question_answers)
                                                                                  : activityQuestion.question_answers || [];
                                                                                  
                                                                return answers.map(
                                                                  (
                                                                    activityQuestionAns2,
                                                                    indexQuestionAns2
                                                                  ) => {
                                                                    if (
                                                                      activityQuestionAns2 &&
                                                                      activityQuestionAns2.english_answer_text
                                                                    ) {
      
                                                                      const cleanText = activityQuestionAns2.english_answer_text
                                                                      .replace(/&nbsp;/g, '')
                                                                      .replace(/`/g, '')
                                                                      .replace(/<[^>]*>/g, '')
                                                                      .trim();
                    
                                                                        const hasImage = /<img\s+[^>]*>/gi.test(activityQuestionAns2.english_answer_text);
                          
                                                                        if (!cleanText && !hasImage) {
                                                                            return null; // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                        }
                                                                      serialNumber++ // Increment serial number only if there's a valid answer text
      
                                                                      return (
                                                                        <li
                                                                          key={
                                                                            indexQuestionAns2
                                                                          }
                                                                          className={
                                                                            ""
                                                                          }
                                                                        >
                                                                          {activityQuestion.english_question_part_answer_type === 4 ? 
                                                                          <div className="p-2 px-3 font-size-18">
                                                                            {
                                                                              serialNumber
                                                                            }
                                                                          </div> : null}
                                                                          <div className="p-2 px-3 dg-media border-start-display">
                                                                            <div
                                                                              dangerouslySetInnerHTML={{
                                                                                __html:
                                                                                  activityQuestionAns2.english_answer_text,
                                                                              }}
                                                                            />
                                                                          </div>
                                                                        </li>
                                                                      )
                                                                    }
      
                                                                    return null // Skip rendering if answer text is null
                                                                  }
                                                                )
                                                              })()}
                                                          </ul>
                                                        </>
                                                      )}
      
                                                    
                                                    {activity.question_details &&
                                                      activity.question_details
                                                        .english_question_new_category &&
                                                      activity.question_details
                                                        .english_question_new_category
                                                        .english_question_category_id ==
                                                        8 && (
                                                        <>
                                                          <div className="p-2 px-3 font-size-18">
                                                            {activityQuestion &&
                                                            activityQuestion.english_question_part_text ? (
                                                              <div
                                                                dangerouslySetInnerHTML={{
                                                                  __html: `${
                                                                    indexactivityQuestion +
                                                                    1
                                                                  }) ${activityQuestion.english_question_part_text
                                                                    .replace(
                                                                      /\[(\d+)Answer char=\d+\]/g,
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      /\[Answer char=\d+\]/g,
                                                                      ""
                                                                    )}`,
                                                                }}
                                                              />
                                                            ) : (
                                                              ""
                                                            )}
                                                          </div>
      
                                                          <ul className="dg-selector list-unstyled mb-0 pt-4">
                                                          {parseInt(activityQuestion.english_question_part_automark) === 0? <div className="d-flex justify-content-end mb-2"><div className="badge bg-primary text-white font-size-12 mb-0" style={{color: 'white'}}>Manual Marking</div></div> : null}
                                                            {activityQuestion &&
                                                              activityQuestion.question_answers &&
                                                              (() => {
                                                                let serialNumber = 0 // Separate counter for serial number
                                                                const answers = activityQuestion.english_question_part_answer_type === 4
                                                                ? rearrangeEvenOdd(activityQuestion.question_answers)
                                                                : activityQuestion.question_answers || [];
                                                                // return rearrangeEvenOdd(
                                                                //   activityQuestion.question_answers
                                                                // ).map(
                                                                  return answers.map((
                                                                    activityQuestionAns,
                                                                    indexQuestionAns
                                                                  ) => {
                                                                    if (
                                                                      activityQuestionAns &&
                                                                      activityQuestionAns.english_answer_text
                                                                    ) {
                                                                      const cleanText = activityQuestionAns.english_answer_text
                                                                      .replace(/&nbsp;/g, '')
                                                                      .replace(/`/g, '')
                                                                      .replace(/<[^>]*>/g, '')
                                                                      .trim();
                    
                                                                        const hasImage = /<img\s+[^>]*>/gi.test(activityQuestionAns.english_answer_text);
                          
                                                                        if (!cleanText && !hasImage) {
                                                                            return null; // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                        }
                                                                      serialNumber++ // Increment serial number only if answer text is valid
      
                                                                      return (
                                                                        <li
                                                                          key={
                                                                            indexQuestionAns
                                                                          }
                                                                          className={
                                                                            activityQuestionAns.english_answer_is_correct ==
                                                                            1
                                                                              ? "selector-display"
                                                                              : ""
                                                                          }
                                                                        >
                                                                          {activityQuestion.english_question_part_answer_type === 4 ?
                                                                            <div className="p-2 px-3 font-size-18">
                                                                            {
                                                                              serialNumber
                                                                            }
                                                                          </div>
                                                                          : null}
                                                                          <div className="p-2 px-3 dg-media border-start-display">
                                                                            <div
                                                                              dangerouslySetInnerHTML={{
                                                                                __html:
                                                                                  activityQuestionAns.english_answer_text,
                                                                              }}
                                                                            />
                                                                          </div>
                                                                        </li>
                                                                      )
                                                                    }
      
                                                                    return null // Skip if answer text is null
                                                                  }
                                                                )
                                                              })()}
                                                          </ul>
                                                        </>
                                                      )}
                                                    
                                                    {activity.question_details &&
                                                      activity.question_details
                                                        .english_question_new_category &&
                                                      (parseInt(
                                                        activity.question_details
                                                          .english_question_new_category
                                                          .english_question_category_id
                                                      ) === 13 ||
                                                        parseInt(
                                                          activity.question_details
                                                            .english_question_new_category
                                                            .english_question_category_id
                                                        ) === 10) && (
                                                        <>
                                                          {/* <ul className="dg-selector list-unstyled mb-0 pt-4"> */}
                                                          <div class="q_a-preview pt-3 d-flex justify-content-between align-items-center">
                                                            {activityQuestion &&
                                                            activityQuestion.english_question_part_text ? (
                                                              <div
                                                                dangerouslySetInnerHTML={{
                                                                  __html:
                                                                    activityQuestion.english_question_part_text
                                                                      .replace(
                                                                        /\[(\d+)Answer char=\d+\]/g,
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        /\[Answer char=\d+\]/g,
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        /\[\[(.+?)\]\]/g,
                                                                        function (
                                                                          match,
                                                                          p1
                                                                        ) {
                                                                          return p1.length >
                                                                            1
                                                                            ? `<span class="text-bg-yellow">${p1}</span>`
                                                                            : `<span class="text-bg-blue">${p1}</span>`
                                                                        }
                                                                      )
                                                                      .replace(
                                                                        /\{\{/g,
                                                                        "<u>"
                                                                      )
                                                                      .replace(
                                                                        /\}\}/g,
                                                                        "</u>"
                                                                      ),
                                                                }}
                                                              />
                                                            ) : (
                                                              ""
                                                            )}
                                                            {/* <div className="">{activityQuestion.english_question_part_text} </div> */}
                                                            
                                                            {activityQuestion &&
                                                              activityQuestion.question_answers &&
                                                              activityQuestion
                                                                .question_answers
                                                                .length > 0 &&
                                                              activityQuestion
                                                                .question_answers[0]
                                                                .english_answer_text &&
                                                              activityQuestion
                                                                .question_answers[0]
                                                                .english_answer_text !=
                                                                "" &&
                                                              activityQuestion.question_answers.map(
                                                                (
                                                                  activityQuestionAns,
                                                                  indexQuestionAns
                                                                ) => (
                                                                  <div>
                                                                  {parseInt(activityQuestion.english_question_part_automark) === 0? <div className="d-flex justify-content-end mb-2"><div className="badge bg-primary text-white font-size-12 mb-0" style={{color: 'white'}}>Manual Marking</div></div> : null}
                                                                  <div
                                                                    className={
                                                                      activityQuestionAns &&
                                                                      activityQuestionAns.english_answer_text
                                                                        ? " myresult "
                                                                        : ""
                                                                    }
                                                                  >
                                                                    {/* <div className="p-2 px-3 px-3 font-size-18">{indexQuestionAns + 1}</div> */}
                                                                    
                                                                    <div
                                                                      className="p-2 px-3 dg-media input_box small_input_box "
                                                                      style={{
                                                                        border:
                                                                          "groove",
                                                                        padding:
                                                                          "10px",
                                                                      }}
                                                                    >
                                                                      {activityQuestionAns &&
                                                                      activityQuestionAns.english_answer_text ? (
                                                                        <div
                                                                          dangerouslySetInnerHTML={{
                                                                            __html:
                                                                              activityQuestionAns.english_answer_text,
                                                                          }}
                                                                        />
                                                                      ) : (
                                                                        ""
                                                                      )}
                                                                    </div>
                                                                  </div>
                                                                  </div>
                                                                )
                                                              )}
                                                          </div>
                                                          {/* </ul> */}
                                                        </>
                                                      )}
                                                  </>
                                                )
                                              )}
                                            </div>
                                          </div>
    
                                          {/* <div className="btn-group d-flex justify-content-between mt-3">
                                            <div>
                                              {parseInt(customActiveTab1) !== 0 && (
                                                <Button
                                                  className="btn d-inline-block cs-btn-danger mt-1"
                                                  onClick={goToPrevTab}
                                                >
                                                  Prev
                                                </Button>
                                              )}
                                            </div>
                                            <div>
                                              {parseInt(customActiveTab1) !==
                                                popupPreviewSummativeData.length -
                                                  1 && (
                                                <Button
                                                  className="btn cs-btn-danger mt-1"
                                                  onClick={goToNextTab}
                                                >
                                                  Next
                                                </Button>
                                              )}
                                            </div>
                                          </div> */}
                                            <div className="btn-group d-flex justify-content-between mt-3">
                                            {/* Left Button (Prev) */}
                                            <div className={parseInt(customActiveTab1) !== 0 ? "" : "invisible"}>
                                              <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={goToPrevTab}>
                                                Prev
                                              </Button>
                                            </div>
    
                                            {/* Middle Button (Replace)
                                            <div className="text-center">
                                              <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={fetchReplaceData}>
                                                Replace
                                              </Button>
                                            </div>
                                              */}
                                            {/* Right Button (Next) */}
                                            <div
                                              className={
                                                parseInt(customActiveTab1) !== parseInt(popupPreviewSummativeData.length) - 1
                                                  ? ""
                                                  : "invisible"
                                              }
                                            >
                                              <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={goToNextTab}>
                                                Next
                                              </Button>
                                            </div>
                                          </div>
                                        </div>
                                      </TabPane>
                                    )
                                  )}
                              </TabContent>
                            </div>
                          </Container>
                        )}
                        {subjectIdData === 2 && (
                          <Container className="custom-wt">
                            <div className="assessement-section assessment-width-hold">
                               <div style={{display: localStorage.getItem("is_trial") == '1' ? "none" : ""}}>
                                  <div className="d-flex justify-content-end me-3">
                                    {/* <span onClick={() => handleDownload(popupPreviewSummativeData)}><i className="mdi mdi-file-pdf-box" style={{fontSize: "30px"}}></i></span> */}
                                  {isDownloading ? (
                                        <div className="spinner-border text-primary" role="status" style={{ width: "30px", height: "30px" }}>
                                          <span className="visually-hidden">Loading...</span>
                                        </div>
                                      ) : (
                                        <span onClick={() => handleDownload(popupPreviewSummativeData)}>
                                          <i className="mdi mdi-file-pdf-box" style={{ fontSize: "30px" }}></i>
                                        </span>
                                  )}
                                  </div>
                                  
                                  <ActivityToPDFConverter ref={pdfRef} ActivityData={currentActivity} type='SummativePopup' name={previewSummativeDetails.name} />
                                </div>
                              <Nav tabs className="md-prev-tab mb-3">
                                {
                                  
                                  popupPreviewSummativeData &&
                                    popupPreviewSummativeData.length > 0 &&
                                    popupPreviewSummativeData.map(
                                      (activity, popactivityindex) => (
                                        <NavItem key={popactivityindex}>
                                          <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={
                                              classnames({
                                                active:
                                                  customActiveTab1 ===
                                                  popactivityindex.toString(),
                                              }) + " display-number"
                                            }
                                            onClick={() =>
                                              toggleCustom1(
                                                popactivityindex.toString()
                                              )
                                            }
                                          >
                                            <span className="font-size-20 fw-800">
                                              {popactivityindex + 1}
                                            </span>
                                          </NavLink>
                                        </NavItem>
                                      )
                                    )
                                }
                              </Nav>
    
                              <TabContent
                                activeTab={customActiveTab1}
                                className="text-muted question_container"
                              >
                                {popupPreviewSummativeData &&
                                  popupPreviewSummativeData.length > 0 &&
                                  popupPreviewSummativeData.map(
                                    (activity, popactivityindex) => (
                                      <TabPane
                                        tabId={popactivityindex.toString()}
                                        key={popactivityindex}
                                      >
                                        {" "}
                                        <div className="hw-list mt-4 pb-100">
                                          {activity &&
                                          activity.question_details &&
                                          activity.question_details.question_text &&
                                          activity.question_details.question_text
                                            .trim()
                                            .toString() != "" ? (
                                            <div class="QuestionBody jss13 mb-5">
                                              <div>
                                                {" "}
                                                {activity.question_details &&
                                                activity.question_details.question_text ? (
                                                  <div
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        activity.question_details.question_text
                                                          .replace(
                                                            /\[(\d+)Answer char=\d+\]/g,
                                                            ""
                                                          )
                                                          .replace(
                                                            /\[Answer char=\d+\]/g,
                                                            ""
                                                          ),
                                                    }}
                                                  />
                                                ) : (
                                                  ""
                                                )}{" "}
                                              </div>
                                            </div>
                                          ) : null}
    
                                          {activity &&
                                            activity.question_details &&
                                            activity.question_details.question_parts &&
                                            activity.question_details.question_parts.map(
                                              activityQuestion => (
                                                <>
                                                  <div class="QuestionBody jss13">
                                                    <div>
                                                      {activityQuestion &&
                                                      activityQuestion.part_text ? (
                                                        <div
                                                          dangerouslySetInnerHTML={{
                                                            __html:
                                                              activityQuestion.part_text
                                                                .replace(
                                                                  /\[(\d+)Answer char=\d+\]/g,
                                                                  ""
                                                                )
                                                                .replace(
                                                                  /\[Answer char=\d+\]/g,
                                                                  ""
                                                                ),
                                                          }}
                                                        />
                                                      ) : (
                                                        ""
                                                      )}
                                                    </div>
                                                  </div>
                                                  
                                                  {activityQuestion &&
                                                    activityQuestion.part_answer_type ==
                                                      4 && (
                                                      <ul className="dg-selector list-unstyled mb-0 pt-4">
                                                        {activityQuestion &&
                                                          activityQuestion.question_answers &&
                                                          (() => {
                                                            let serialNumber = 0 // Separate counter for serial number
                                                            return rearrangeEvenOdd(
                                                              activityQuestion.question_answers
                                                            ).map(
                                                              (
                                                                activityQuestionAns,
                                                                indexQuestionAns
                                                              ) => {
                                                                if (
                                                                  activityQuestionAns &&
                                                                  activityQuestionAns.answer_text
                                                                ) {
                                                                  const cleanText = activityQuestionAns.answer_text
                                                                  .replace(/&nbsp;/g, '')
                                                                  .replace(/`/g, '')
                                                                  .replace(/<[^>]*>/g, '')
                                                                  .trim();
                
                                                                    const hasImage = /<img\s+[^>]*>/gi.test(activityQuestionAns.answer_text);
                      
                                                                    if (!cleanText && !hasImage) {
                                                                        return null; // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                    }
                
                                                                  serialNumber++ // Increment serial number only when answer text is valid
    
                                                                  return (
                                                                    <li
                                                                      key={
                                                                        indexQuestionAns
                                                                      }
                                                                      className={
                                                                        activityQuestionAns.answer_is_correct &&
                                                                        activityQuestionAns.answer_is_correct ==
                                                                          1
                                                                          ? "selector-display"
                                                                          : ""
                                                                      }
                                                                    >
                                                                      <div className="p-2 px-3 font-size-18">
                                                                        {
                                                                          serialNumber
                                                                        }
                                                                      </div>
                                                                      <div className="p-2 px-3 dg-media border-start-display">
                                                                        {activityQuestionAns &&
                                                                        activityQuestionAns.answer_text ? (
                                                                          <div
                                                                            dangerouslySetInnerHTML={{
                                                                              __html:
                                                                                activityQuestionAns.answer_text,
                                                                            }}
                                                                          />
                                                                        ) : (
                                                                          ""
                                                                        )}
                                                                      </div>
                                                                    </li>
                                                                  )
                                                                }
    
                                                                return null // Skip if answer_text is null
                                                              }
                                                            )
                                                          })()}
                                                      </ul>
                                                    )}
                                                  {activityQuestion &&
                                                    activityQuestion.part_answer_type ==
                                                      2 && (
                                                        <div className="d-flex justify-content-end p-0">
                                                          <ul className="dg-selector list-unstyled mb-0 pt-4 w-25 ">
                                                            {activityQuestion &&
                                                              activityQuestion.question_answers &&
                                                              activityQuestion.question_answers.map(
                                                                (
                                                                  activityQuestionAns,
                                                                  indexQuestionAns
                                                                ) =>
                                                                  activityQuestionAns &&
                                                                  activityQuestionAns.answer_text ? (
                                                                    <li className="selector-display-parttype-2">
                                                                      <div className="p-2 px-3 dg-media ">
                                                                        {activityQuestionAns &&
                                                                        activityQuestionAns.answer_text ? (
                                                                          <div
                                                                            dangerouslySetInnerHTML={{
                                                                              __html:
                                                                                activityQuestionAns.answer_text,
                                                                            }}
                                                                          />
                                                                        ) : (
                                                                          ""
                                                                        )}
                                                                      </div>
                                                                    </li>
                                                                  ) : null
                                                              )}
                                                          </ul>
                                                        </div>
                                                    )}
                                                </>
                                              )
                                            )}
    
                                          {/* <div className="btn-group d-flex justify-content-between mt-3">
                                            <div>
                                              {parseInt(customActiveTab1) !== 0 && (
                                                <Button
                                                  className="btn d-inline-block cs-btn-danger mt-1"
                                                  onClick={goToPrevTab}
                                                >
                                                  Prev
                                                </Button>
                                              )}
                                            </div>
                                            <div>
                                            
                                                <Button
                                                  className="btn d-inline-block cs-btn-danger mt-1"
                                                  onClick={ReplaceQus}
                                                >
                                                  Replace
                                                </Button>
                                            
                                            </div>
                                            <div>
                                              {parseInt(customActiveTab1) !==
                                                parseInt(
                                                  popupPreviewSummativeData
                                                    .length
                                                ) -
                                                  1 && (
                                                <Button
                                                  className="btn cs-btn-danger mt-1"
                                                  onClick={goToNextTab}
                                                >
                                                  Next
                                                </Button>
                                              )}
                                            </div>
                                          </div> */}
                                          <div className="btn-group d-flex justify-content-between mt-3">
                                            {/* Left Button (Prev) */}
                                            <div className={parseInt(customActiveTab1) !== 0 ? "" : "invisible"}>
                                              <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={goToPrevTab}>
                                                Prev
                                              </Button>
                                            </div>
    
                                            {/* Middle Button (Replace) */}
                                            {/* <div className="text-center">
                                              <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={fetchReplaceData} >
                                                Replace
                                              </Button>
                                            </div> */}
    
                                            {/* Right Button (Next) */}
                                            <div
                                              className={
                                                parseInt(customActiveTab1) !== parseInt(popupPreviewSummativeData.length) - 1
                                                  ? ""
                                                  : "invisible"
                                              }
                                            >
                                              <Button className="btn d-inline-block cs-btn-danger mt-1" onClick={goToNextTab}>
                                                Next
                                              </Button>
                                            </div>
                                          </div>
    
                                        </div>
                                      </TabPane>
                                    )
                                  )}
                              </TabContent>
                            </div>
                          </Container>
                        )}
                      </ModalBody>
                    </>
                  ) : (
                    ""
                  )}
                </MathJax>
              </Modal>
            </div>
          </div>

          <div className="table-responsive">
            <Table className="table mb-2 cp-cs-pd">
              <thead>
                <tr>
                  <th width="20%">
                    <h6 class="text-dark">Activity Name</h6>
                  </th>
                  <th width="16%">
                    <h6 class="text-dark">Source</h6>
                  </th>
                  <th width="15%">
                    <h6 class="text-dark">Description</h6>
                  </th>
                  <th width="13%">
                    <h6 class="text-dark">Duration</h6>
                  </th>
                  <th width="13%">
                    <h6 class="text-dark">Coins</h6>
                  </th>
                  <th width="13%">
                    <h6 class="text-dark">Date Added</h6>
                  </th>
                  <th width="10%" className="text-end">
                    <h6 class="text-dark"></h6>
                  </th>
                </tr>
              </thead>
            </Table>
          </div>
          <div className="accordion" id="accordion">
            <div className="mb-3">
            {/*summative list start */}
            {summativeActivity && summativeActivity.length > 0 && summativeActivity.slice(0, 1).map((item, index) => {
              const groupedItems = groupItemsBySubjectSummative(summativeActivity)
              console.log(groupedItems)
              return (
                <div className="accordion-item" key={index}>
                  <h2
                    className="accordion-header"
                    id={`heading-summative-${item.index}`}
                  >
                    <button
                     
                      className={`accordion-button fw-semibold  ${
                        openSummativeItems[index] && "collapsed"
                      }`}
                      type="button"
                      onClick={() => toggleSummativeItem(index)}
                      style={{ cursor: "pointer" }}
                    >
                     Summative Activities
                    </button>
                  </h2>

                  <Collapse
                    isOpen={openSummativeItems[index]}
                    className={`accordion-collapse ${
                      openSummativeItems[index] && "show"
                    }`}
                  >
                    <div className="accordion-body p-0">
                      <div className="table-responsive">
                        <div className="accordion">
                          {Object.keys(groupedItems).map(subject => (
                            <div className="accordion-item" key={subject}>
                              <h4
                                className="accordion-header"
                              >
                                <button
                                  className={`accordion-button bg-white fw-semibold  ${
                                    activeSummativeIndex === subject && "collapsed"
                                  }`}
                                  type="button"
                                  onClick={() => togglesummativeAccordion(subject)}
                                  style={{ cursor: "pointer" }}
                                >
                                  {({ 1: "English", 2: "Maths" }[subject] || "Others") || subject}
                                </button>
                               
                              </h4>
                              <Collapse
                                isOpen={activeSummativeIndex === subject}
                                className={`accordion-collapse ${
                                  activeSummativeIndex === subject && "show"
                                }`}
                              >
                                <div className="accordion-body p-0">
                                  <Table className="table mb-0 cp-cs-pd">
                                    <tbody>
                                      {groupedItems[subject].map(
                                        (items, itemIndex) => (
                                          <tr>
                                            <th scope="row" width="20%">
                                              {items.name == null ||
                                              items.name == ""
                                                ? "-"
                                                : items.name}
                                            </th>
                                            <td width="16%">
                                             -
                                            </td>
                                            <td width="15%">
                                              {items.description == null ||
                                              items.description == ""
                                                ? "-"
                                                : items.description}
                                            </td>
                                            <td width="13%">
                                              {" "}
                                              -
                                            </td>
                                            <td width="13%">
                                             
                                                -
                                            </td>
                                            <td width="13%">
                                              {items.createdAt == null ||
                                              items.createdAt == ""
                                                ? "-"
                                                : moment(
                                                    items.createdAt,
                                                    "YYYY-MM-DDTHH:mm:ssZ"
                                                  ).format("DD MMM YYYY")}
                                            </td>
                                            <td
                                              width="10%"
                                              className="text-end"
                                              
                                            >
                                              <Tooltip
                                                placement="top"
                                                isOpen={ttop2}
                                                target="TooltipTop2"
                                                toggle={() => {
                                                  setttop2(!ttop2)
                                                }}
                                              >
                                                View
                                              </Tooltip>
                                              <button
                                                onClick={() => {
                                                  fetchpreviewSummativeData(items)
                                                 
                                                }}
                                                id="TooltipTop2"
                                                className="btn btn-action btn-sm me-1"
                                              >
                                                <i className="fas fa-eye"></i>
                                              </button>

                                              <Tooltip
                                                placement="top"
                                                isOpen={ttop1}
                                                target="TooltipTop3"
                                                toggle={() => {
                                                  setttop1(!ttop1)
                                                }}
                                              >
                                                Delete
                                              </Tooltip>
                                              <button
                                                id="TooltipTop3"
                                                onClick={() => {
                                                  setDeleteSummativedata(
                                                    items.id
                                                  )
                                                  tog_summative()
                                                }}
                                                className="btn btn-action btn-sm"
                                              >
                                                <i className="fas fa-trash-alt"></i>
                                              </button>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </Table>
                                </div>
                              </Collapse>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              )
            })}
            {/* summative list end */}
            </div>
            {/* mylibary list start */}
            <div className="position-relative" style={{ marginTop: "36px" }}>
              <Nav
                tabs
                className="nav-tabs-custom activitytb"
                style={{ marginBottom: "10px" }}
              >
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: libraryTabs === "1",
                    })}
                    onClick={() => {
                      toggleLibraryCustomTab("1")
                    }}
                  >
                    <span className="d-none d-sm-block">My Library</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer"}}
                    className={classnames({
                      active: libraryTabs === "2",
                    })}
                    onClick={() => {
                      toggleLibraryCustomTab("2")
                    }}
                  >
                    <span className="d-none d-sm-block">Centre Library</span>
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
            <TabContent
              activeTab={libraryTabs}
              className="activity-scroll"
            >
              <TabPane tabId="1">
                <div className="table-responsive">
                  <Table className="table mb-2 cp-cs-pd">
                    <thead>
                      <tr>
                        <th width="20%">
                          <h6 class="text-dark">Activity Name</h6>
                        </th>
                        <th width="16%">
                          <h6 class="text-dark">Source</h6>
                        </th>
                        <th width="15%">
                          <h6 class="text-dark">Description</h6>
                        </th>
                        <th width="13%">
                          <h6 class="text-dark">Duration</h6>
                        </th>
                        <th width="13%">
                          <h6 class="text-dark">Coins</h6>
                        </th>
                        <th width="13%">
                          <h6 class="text-dark">Date Added</h6>
                        </th>
                        <th width="10%" className="text-end">
                          <h6 class="text-dark"></h6>
                        </th>
                      </tr>
                    </thead>
                  </Table>
                </div>
                <div className="">
                  {/* My library actvitys */}
                  {dataTableData.filter(item => Array.isArray(item.TutorLibraryItems) && item.TutorLibraryItems.length > 0).length === 0
                  ? <div className="text-center">Not found any other data</div>
                  : dataTableData.filter(item => Array.isArray(item.TutorLibraryItems) && item.TutorLibraryItems.length > 0)
                    .map((item, index) => {
                    console.log(item)
                    // const foldersGrouped = groupByFolder(item.TutorLibraryItems)
                      const _groupItemsByFolderActivityType = groupItemsByFolderActivityType(item.TutorLibraryItems)
                      const foldersGrouped = _groupItemsByFolderActivityType.items;

                      const sortedFolderKeys = _groupItemsByFolderActivityType.sortedKeys;

                    return (
                      <div className="accordion-item" key={index}>
                        <h2 className="accordion-header" id={`heading-subject-${item.subject_id}`}>
                          <button
                            className={`accordion-button fw-semibold ${openItems[index] && "collapsed"}`}
                            type="button"
                            onClick={() => toggleItem(index)}
                            style={{ cursor: "pointer" }}
                          >
                            {item.subject_name}
                          </button>
                        </h2>

                        <Collapse isOpen={openItems[index]} className={`accordion-collapse ${openItems[index] && "show"}`}>
                          <div className="accordion-body p-0">
                            <div className="accordion">
                              {/* Loop through folders */}
                              {sortedFolderKeys.map(folderKey => {
                                const folderData = foldersGrouped[folderKey];
                                // const groupedItems = groupItemsByType(folderData.items)
                                const groupedItems = folderData.items;

                                const sortedActivityKeys = folderData.sortedKeys;

                                return (
                                  <div className="accordion-item" key={folderKey}>
                                    <h4 className="accordion-header">
                                      <button
                                        className={`accordion-button bg-light fw-semibold ${
                                          openFolderItems[index]?.[folderKey] && "collapsed"
                                        }`}
                                        type="button"
                                        onClick={() => toggleFolderItem(index, folderKey)}
                                        style={{ cursor: "pointer" }}
                                      >
                                        {folderData.folder_name}
                                      </button>
                                    </h4>

                                    <Collapse isOpen={!!openFolderItems[index]?.[folderKey]}>
                                      <div className="accordion-body p-0">
                                        {/* Grouped by activity type */}
                                        {sortedActivityKeys.map(type => (
                                          <div className="accordion-item" key={type}>
                                            <h5 className="accordion-header">
                                              <button
                                                className={`accordion-button bg-white fw-semibold ${
                                                  openTypeItems[index]?.[folderKey]?.[type] && "collapsed"
                                                }`}
                                                type="button"
                                                onClick={() => toggleTypeItem(index, folderKey, type)}
                                                style={{ cursor: "pointer" }}
                                              >
                                                {activityTypeMap[type] || type}
                                              </button>
                                            </h5>

                                            <Collapse isOpen={!!openTypeItems[index]?.[folderKey]?.[type]}>
                                              <div className="accordion-body p-0">
                                                <Table className="table mb-0 cp-cs-pd">
                                                  <tbody>
                                                    {groupedItems[type].items.map(
                                                      (_item, itemIndex) => (
                                                        <tr>
                                                          <th scope="row" width="20%">
                                                            {_item.name || "-"}
                                                          </th>
                                                          <td width="16%">
                                                            {_item.source || "-"}
                                                          </td>
                                                          <td width="15%">
                                                            {_item.description || "-"}
                                                          </td>
                                                          <td width="13%">
                                                            {" "}
                                                            {_item.duration || "-"}
                                                          </td>
                                                          <td width="13%">
                                                            {/* {_item.activity_type == null ||
                                                            _item.activity_type == ""
                                                              ? "-"
                                                              : _item.activity_type == "1"
                                                              ? "Video"
                                                              : _item.activity_type == "3"
                                                              ? "Link"
                                                              : _item.activity_type == "4"
                                                              ? "Task"
                                                              : _item.activity_type == "5"
                                                              ? "WorkSheet"
                                                              : "-"} */}
                                                              {_item.coins || "-"}
                                                          </td>
                                                          <td width="13%">
                                                            {_item.created_on == null ||
                                                            _item.created_on == ""
                                                              ? "-"
                                                              : moment(
                                                                _item.created_on,
                                                                  "YYYY-MM-DDTHH:mm:ssZ"
                                                                ).format("DD MMM YYYY")}
                                                          </td>
                                                          <td
                                                            width="10%"
                                                            className="text-end"
                                                            
                                                          >
                                                            <Tooltip
                                                              placement="top"
                                                              isOpen={ttop}
                                                              target="TooltipTop"
                                                              toggle={() => {
                                                                setttop(!ttop)
                                                              }}
                                                            >
                                                              Edit
                                                            </Tooltip>
                                                            <button
                                                              onClick={() => {
                                                                handleRowEditActivityClick(
                                                                  _item
                                                                )
                                                                tog_large1()
                                                              }}
                                                              id="TooltipTop"
                                                              className="btn btn-action btn-sm me-1"
                                                            >
                                                              <i className="fas fa-pen"></i>
                                                            </button>

                                                            <Tooltip
                                                              placement="top"
                                                              isOpen={ttop1}
                                                              target="TooltipTop1"
                                                              toggle={() => {
                                                                setttop1(!ttop1)
                                                              }}
                                                            >
                                                              Delete
                                                            </Tooltip>
                                                            <button
                                                              id="TooltipTop1"
                                                              onClick={() => {
                                                                setAllDeleteMylibrarydata(
                                                                  _item.pk_tutor_library_item_key
                                                                )
                                                                tog_center()
                                                              }}
                                                              className="btn btn-action btn-sm"
                                                            >
                                                              <i className="fas fa-trash-alt"></i>
                                                            </button>
                                                          </td>
                                                        </tr>
                                                      )
                                                    )}
                                                  </tbody>
                                                </Table>
                                              </div>
                                            </Collapse>
                                          </div>
                                        ))}
                                      </div>
                                    </Collapse>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        </Collapse>
                      </div>
                    )
                  })}
                </div>
              </TabPane>
              <TabPane tabId="2">
                <div className="table-responsive">
                  <Table className="table mb-2 cp-cs-pd">
                    <thead>
                      <tr>
                        <th width="20%">
                          <h6 class="text-dark">Activity Name</h6>
                        </th>
                        <th width="16%">
                          <h6 class="text-dark">Source</h6>
                        </th>
                        <th width="15%">
                          <h6 class="text-dark">Description</h6>
                        </th>
                        <th width="13%">
                          <h6 class="text-dark">Duration</h6>
                        </th>
                        <th width="13%">
                          <h6 class="text-dark">Coins</h6>
                        </th>
                        <th width="13%">
                          <h6 class="text-dark">Date Added</h6>
                        </th>
                        <th width="10%" className="text-end">
                          <h6 class="text-dark">Tutor</h6>
                        </th>
                      </tr>
                    </thead>
                  </Table>
                </div>
                <div className="">
                  {dataTableOtherTutorData.filter(item => Array.isArray(item.TutorLibraryItems) && item.TutorLibraryItems.length > 0).length === 0
                  ? <div className="text-center">Not found any other data</div>
                  : dataTableOtherTutorData.filter(item => Array.isArray(item.TutorLibraryItems) && item.TutorLibraryItems.length > 0)
                    .map((item, index) => {

                    const _groupItemsByFolderActivityType = groupItemsByFolderActivityType(item.TutorLibraryItems)

                    const foldersGrouped = _groupItemsByFolderActivityType.items;
                    const sortedFolderKeys = _groupItemsByFolderActivityType.sortedKeys;

                    return (
                      <div className="accordion-item" key={index}>
                        <h2 className="accordion-header" id={`heading-subject-${item.subject_id}`}>
                          <button
                            className={`accordion-button fw-semibold ${openItems[index] && "collapsed"}`}
                            type="button"
                            onClick={() => toggleItem(index)}
                            style={{ cursor: "pointer" }}
                          >
                            {item.subject_name}
                          </button>
                        </h2>

                        <Collapse isOpen={openItems[index]} className={`accordion-collapse ${openItems[index] && "show"}`}>
                          <div className="accordion-body p-0">
                            <div className="accordion">
                              {/* Loop through folders */}
                              {/*{Object.keys(foldersGrouped).map(folderKey => {*/}
                              {sortedFolderKeys.map(folderKey => {
                                const folderData = foldersGrouped[folderKey]
                                // const groupedItems = groupItemsByType(folderData.items)
                                const groupedItems = folderData.items;
                                const sortedActivityKeys = folderData.sortedKeys;

                                return (
                                  <div className="accordion-item" key={folderKey}>
                                    <h4 className="accordion-header">
                                      <button
                                        className={`accordion-button bg-light fw-semibold ${
                                          openFolderItems[index]?.[folderKey] && "collapsed"
                                        }`}
                                        type="button"
                                        onClick={() => toggleFolderItem(index, folderKey)}
                                        style={{ cursor: "pointer" }}
                                      >
                                        {folderData.folder_name}
                                      </button>
                                    </h4>

                                    <Collapse isOpen={!!openFolderItems[index]?.[folderKey]}>
                                      <div className="accordion-body p-0">
                                        {/* Grouped by activity type */}
                                        {/*{Object.keys(groupedItems).map(type => (*/}
                                        {sortedActivityKeys.map(type => (
                                          <div className="accordion-item" key={type}>
                                            <h5 className="accordion-header">
                                              <button
                                                className={`accordion-button bg-white fw-semibold ${
                                                  openTypeItems[index]?.[folderKey]?.[type] && "collapsed"
                                                }`}
                                                type="button"
                                                onClick={() => toggleTypeItem(index, folderKey, type)}
                                                style={{ cursor: "pointer" }}
                                              >
                                                {activityTypeMap[type] || type}
                                              </button>
                                            </h5>

                                            <Collapse isOpen={!!openTypeItems[index]?.[folderKey]?.[type]}>
                                              <div className="accordion-body p-0">
                                                <Table className="table mb-0 cp-cs-pd">
                                                  <tbody>
                                                    {groupedItems[type].items.map(
                                                      (_item, itemIndex) => (
                                                        <tr>
                                                          <th scope="row" width="20%">
                                                            {_item.name || "-"}
                                                          </th>
                                                          <td width="16%">
                                                            {_item.source || "-"}
                                                          </td>
                                                          <td width="15%">
                                                            {_item.description || "-"}
                                                          </td>
                                                          <td width="13%">
                                                            {" "}
                                                            {_item.duration || "-"}
                                                          </td>
                                                          <td width="13%">
                                                            {/* {_item.activity_type == null ||
                                                            _item.activity_type == ""
                                                              ? "-"
                                                              : _item.activity_type == "1"
                                                              ? "Video"
                                                              : _item.activity_type == "3"
                                                              ? "Link"
                                                              : _item.activity_type == "4"
                                                              ? "Task"
                                                              : _item.activity_type == "5"
                                                              ? "WorkSheet"
                                                              : "-"} */}
                                                              {_item.coins || "-"}
                                                          </td>
                                                          <td width="13%">
                                                            {_item.created_on == null ||
                                                            _item.created_on == ""
                                                              ? "-"
                                                              : moment(
                                                                _item.created_on,
                                                                  "YYYY-MM-DDTHH:mm:ssZ"
                                                                ).format("DD MMM YYYY")}
                                                          </td>
                                                          <td
                                                            width="10%"
                                                            className="text-end"
                                                            
                                                          >
                                                             {_item.tut_fname == null ||
                                                             _item.tut_fname == ""
                                                                ? "-"
                                                                : _item.tut_fname+' '+_item.tut_surname}
                                                          </td>
                                                        </tr>
                                                      )
                                                    )}
                                                  </tbody>
                                                </Table>
                                              </div>
                                            </Collapse>
                                          </div>
                                        ))}
                                      </div>
                                    </Collapse>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        </Collapse>
                      </div>
                    )
                  })}
                </div>
              </TabPane>
            </TabContent>
            {/* mylibary list end */}
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

LibraryDetails.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(LibraryDetails)
